import {createI18n} from 'vue-i18n';

const messages = {
    en: {
        "Statistics": "Statistics",
        "Sales summary": "Sales summary",
        "Total revenue": "Total revenue",
        "Transaction count": "Transaction count",
        "Average check": "Average check",
        "Revenue trend": "Revenue trend",
        "Top products": "Top products",
        "By revenue": "By revenue",
        "By quantity": "By quantity",
        "By expenses": "By expenses",
        "Operations": "Operations",
        "Income operations": "Income operations",
        "Expense operations": "Expense operations",
        "Income total": "Income total",
        "Expense total": "Expense total",
        "Sales total": "Sales total (goods + services)",
        "Customer analytics": "Customer analytics",
        "Top customers": "Top customers",
        "New customers": "New customers",
        "Returning customers": "Returning customers",
        "Staff performance": "Staff performance",
        "Payment distribution": "Payment distribution",
        "No data for the selected period": "No data for the selected period",
        "Date from": "Date from",
        "Date to": "Date to",
        "Good type": "Good type",
        "All types": "All types",
        "Revenue": "Revenue",
        "Total spent": "Total spent",
        "View statistics": "View statistics",
        "View bank accounts": "View bank accounts",
        "View all appointments": "View all appointments",
        "Manage appointments": "Manage appointments",
        "Edit staff services": "Edit master services",
        "Master services": "Master services",
        "Select master to edit services": "Select master to edit services",
        "Search services...": "Search services...",
        "Staff services updated": "Master services updated",
        "Services": "Services",
        "min": "min",
        "No payouts and accruals for the selected period and staff": "No payouts and accruals for the selected period and staff",
        "D": "D",
        "N": "N",
        "A": "A",
        "S": "S",
        "V": "V",
        "H": "H",
        "MON": "MON",
        "TUE": "TUE",
        "WED": "WED",
        "THU": "THU",
        "FRI": "FRI",
        "SAT": "SAT",
        "SUN": "SUN",
        "Your account has been deleted!": "Your account has been deleted!",
        "Delete account": "Delete account",
        "Activate": "Activate",
        "Please wait. Signing out...": "Please wait. Signing out...",
        "Current name": "Current name",
        "Current specifications": "Current specifications",
        "No operations": "No operations",
        "Add at least one before creating a income / expense": "Add at least one before creating a income / expense",
        "Add at least one before creating a sale.": "Add at least one before creating a sale.",
        "No products and services": "No products and services",
        "Add product or service": "Add product or service",
        "More": "More",
        "Clients": "Clients",
        "Discounts will be applied automatically": "Discounts will be applied automatically",
        "Update client": "Update client",
        "Attach": "Attach",
        "Detach": "Detach",
        "New quantity": "New quantity",
        "Quantity to": "Quantity to",
        "Quantity from": "Quantity from",
        "Specification name": "Specification name",
        "Specification value": "Specification value",
        "Add specification": "Add specification",
        "Add value": "Add value",
        "Select all": "Select all",
        "Change role": "Change role",
        "Complete": "Complete",
        "completed": "completed",
        "pc": "pc",
        "pcs": "pcs",
        "Apply filter": "Apply filter",
        "Interface language": "Interface language",
        "Loading...": "Loading...",
        "Sign out": "Sign out",
        "Cash registers": "Points of sale",
        "Cash register": "Point of sale",
        "Current cash register": "Current point of sale",
        "Clients and discounts": "Clients and discounts",
        "Catalog and supplies": "Catalog and supplies",
        "Catalog": "Catalog",
        "Category": "Category",
        "Categories": "Categories",
        "All categories": "All categories",
        "Uncategorized": "Uncategorized",
        "New category": "New category",
        "Add subcategory": "Add subcategory",
        "Category name": "Category name",
        "Parent category": "Parent category",
        "Rename": "Rename",
        "Delete with subcategories": "Delete with subcategories",
        "Move subcategories up": "Move subcategories up",
        "Category successfully added": "Category successfully added",
        "Category successfully updated": "Category successfully updated",
        "Category successfully deleted": "Category successfully deleted",
        "This category has subcategories. Choose what to do with them:": "This category has subcategories. Choose what to do with them:",
        "Items in this category will become uncategorized.": "Items in this category will become uncategorized.",
        "Select category": "Select category",
        "Add to category": "Add to category",
        "Category assigned successfully": "Category assigned successfully",
        "Failed to select all matching items. Please retry.": "Failed to select all matching items. Please retry.",
        "Failed to load some categories. Please refresh.": "Failed to load some categories. Please refresh.",
        "Failed to save category": "Failed to save category",
        "Failed to delete category": "Failed to delete category",
        "Failed to assign category": "Failed to assign category",
        "This staff member is already in your company": "This staff member is already in your company",
        "Selected": "Selected",
        "Supplies": "Supplies",
        "Schedules and salaries": "Schedules and salaries",
        "Staff members": "Staff members",
        "Staff member": "Staff member",
        "Plans": "Plans",
        "Your trial period ends today": "Your trial period ends today",
        "Your trial period ends in {days} days": "Your trial period ends in {days} days",
        "Choose a plan →": "Choose a plan →",
        "Your trial period ends today. Please choose the plan that suits you best.": "Your trial period ends today. Please choose the plan that suits you best.",
        "Your trial period ends in {days} days. Please choose the plan that suits you best.": "Your trial period ends in {days} days. Please choose the plan that suits you best.",
        "Okay": "Okay",
        "Yes, I'm sure": "Yes, I'm sure",
        "Cancel": "Cancel",
        "Recalculate discounts": "Recalculate discounts",
        "Keep current discounts": "Keep current discounts",
        "A discount policy is attached to the company's main currency. Would you like to recalculate the discounts for your clients according to the new main currency?": "A discount policy is attached to the company's main currency. Would you like to recalculate the discounts for your clients according to the new main currency?",
        "Save": "Save",
        "Personal data": "Personal data",
        "Full name": "Full name",
        "Name": "Name",
        "Company name": "Company name",
        "Official company name": "Official company name",
        "Phone number": "Phone number",
        "Edit": "Edit",
        "Copy": "Copy",
        "Email": "Email",
        "Personal token": "Personal token",
        "Company data": "Company data",
        "Main currency": "Main currency",
        "Plan": "Plan",
        "The token has been successfully copied": "The token has been successfully copied",
        "Failed to copy the token...": "Failed to copy the token...",
        "Valid until": "Valid until",
        "month": "month",
        "The official company name field is required.": "The official company name field is required.",
        "The company name field is required.": "The company name field is required.",
        "The full name field is required.": "The full name field is required.",
        "The name field is required": "The name field is required",
        "Add": "Add",
        "New payout": "New payout",
        "New accrual": "New accrual",
        "Period": "Period",
        "Payout type": "Payout type",
        "Amount": "Amount",
        "Salary calculation": "Salary calculation",
        "Created by": "Created by",
        "Comment": "Comment",
        "The payout amount field is required.": "The payout amount field is required.",
        "The staff member field is required": "The staff member field is required",
        "The period field is required": "The period field is required",
        "The payout type field is required": "The payout type field is required",
        "New staff member": "New staff member",
        "Staff member's pay rates": "Staff member's pay rates",
        "Sales commission": "Sales commission",
        "Day shift rate": "Day shift rate",
        "Day hourly rate": "Day hourly rate",
        "Night shift rate": "Night shift rate",
        "Night hourly rate": "Night hourly rate",
        "Vacation day rate": "Vacation day rate",
        "Add another rate type": "Add another rate type",
        "Add payment method": "Add payment method",
        "The phone number field is required.": "The phone number field is required.",
        "Please enter a valid phone number.": "Please enter a valid phone number.",
        "The token field is required. You can obtain the token from the staff member you wish to add.": "The token field is required. You can obtain the token from the staff member you wish to add.",
        "Payout rate types cannot be duplicated.": "Payout rate types cannot be duplicated.",
        "Staff members cannot be duplicated": "Staff members cannot be duplicated",
        "User with this token not found. Please make sure the token is correct and that the staff member is registered on Intilly.": "User with this token not found. Please make sure the token is correct and that the staff member is registered on Intilly.",
        "You cannot add yourself as a staff member.": "You cannot add yourself as a staff member.",
        "This staff member is already in your company.": "This staff member is already in your company.",
        "Without account (payroll only)": "Without account (payroll only)",
        "Link account": "Link account",
        "Account linked successfully": "Account linked successfully",
        "Staff member without account": "Staff member without account",
        "Payout details": "Payout details",
        "Accrual details": "Accrual details",
        "Delete": "Delete",
        "deleted": "deleted",
        "Creation date": "Creation date",
        "Time": "Time",
        "Are you sure you want to delete this payout?": "Are you sure you want to delete this payout?",
        "Export": "Export",
        "Export data": "Export data",
        "From period": "From period",
        "To period": "To period",
        "Add signature form": "Add signature form",
        "Print export": "Print export",
        "All cash registers": "All points of sale",
        "The plugin is in beta and is available to all users for free for testing and feedback purposes": "The plugin is in beta and is available to all users for free for testing and feedback purposes",
        "You currently have no active staff members": "You currently have no active staff members",
        "You currently have no staff members": "You currently have no staff members",
        "There are currently no active staff members in the selected cash register": "There are currently no active staff members in the selected point of sale",
        "Staff schedule table for {period}": "Staff schedule table for {period}",
        "Day hours": "Day hours",
        "Night hours": "Night hours",
        "Day shift": "Day shift",
        "Night shift": "Night shift",
        "Absence": "Absence",
        "Absences": "Absences",
        "Sick leave": "Sick leave",
        "Sick leaves": "Sick leaves",
        "Vacation": "Vacation",
        "Empty": "Empty",
        "Print": "Print",
        "% from sales": "% from sales",
        "Day shifts": "Day shifts",
        "Night shifts": "Night shifts",
        "Vacation days": "Vacation days",
        "Total": "Total",
        "Penalties": "Penalties",
        "Paid out": "Paid out",
        "Remaining payout": "Remaining payout",
        "Salary calculation table for {period}": "Salary calculation table for {period}",
        "Salary calculation table": "Salary calculation table",
        "Payout and accrual table for {period}": "Payout and accrual table for {period}",
        "Date": "Date",
        "Who made": "Who made",
        "No payouts for the selected period": "No payouts for the selected period",
        "The work schedule and salary plugin operates on data starting from February 2025": "The work schedule and salary plugin operates on data starting from February 2025",
        "Work schedule": "Work schedule",
        "Sale commission": "Sale commission",
        "Schedule table": "Schedule table",
        "Staff member's report": "Staff member's report",
        "Payout table": "Payout table",
        "Signature": "Signature",
        "Founder": "Founder",
        "Report creation date": "Report creation date",
        "Hidden staff members remain in the system but cannot perform operations or view data in your company. Are you sure you want to hide the staff member?": "Hidden staff members remain in the system but cannot perform operations or view data in your company. Are you sure you want to hide the staff member?",
        "Active staff members regain access to performing operations and viewing data in your company. Are you sure you want to activate this staff member?": "Active staff members regain access to performing operations and viewing data in your company. Are you sure you want to activate this staff member?",
        "Deleted staff members are removed from your database and lose access to performing operations and viewing data in your company. To grant access to this staff member again, you will need to re-add them. Are you sure you want to delete this staff member?": "Deleted staff members are removed from your database and lose access to performing operations and viewing data in your company. To grant access to this staff member again, you will need to re-add them. Are you sure you want to delete this staff member?",
        "Staff member update": "Staff member update",
        "For those who want to use more and pay less": "For those who want to use more and pay less",
        "For those who want flexible monthly subscription management": "For those who want flexible monthly subscription management",
        "For those who want to try the service before buying": "For those who want to try the service before buying",
        "Limited number of cash registers": "Limited number of points of sale",
        "Up to 10 transactions per day": "Up to 10 transactions per day",
        "Unlimited number of staff members": "Unlimited number of staff members",
        "Unlimited number of products": "Unlimited number of products",
        "Unlimited number of clients": "Unlimited number of clients",
        "Unlimited number of transactions": "Unlimited number of transactions",
        "Selected number of cash registers": "Selected number of points of sale",
        "Free": "Free",
        "Monthly": "Monthly",
        "Annual": "Annual",
        "Number of cash registers": "Number of points of sale",
        "per month": "per month",
        "per year": "per year",
        "discount": "discount",
        "I have a promo code": "I have a promo code",
        "Apply": "Apply",
        "Your current plan": "Your current plan",
        "Subscribe": "Subscribe",
        "New cash register": "New point of sale",
        "First cash register": "First point of sale",
        "Cash register name": "Point of sale name",
        "Address": "Address",
        "City (timezone selection)": "City (timezone selection)",
        "City": "City",
        "Timezone": "Timezone",
        "Please enter a city": "Please enter a city",
        "Please select a timezone": "Please select a timezone",
        "No results were found for your query": "No results were found for your query",
        "Available payment methods": "Available payment methods",
        "Cash": "Cash",
        "Card": "Card",
        "Bank account": "Bank account",
        "Terminal": "Terminal",
        "cash": "Cash",
        "account": "Bank account",
        "card": "Card",
        "terminal": "Terminal",
        "cash_today": "Cash in register",
        "card_today": "By card",
        "terminal_today": "By terminal",
        "account_today": "To settlement account",
        "Withdrawal account": "Withdrawal account",
        "Deposit account": "Deposit account",
        "Default payment method": "Default payment method",
        "The payment method field is required": "The payment method field is required",
        "Not selected": "Not selected",
        "Default currency": "Default currency",
        "Staff guide": "Staff guide",
        "Guide": "Guide",
        "Next": "Next",
        "Back": "Back",
        "Adding items, services, and transactions to the new cash register": "Adding items, services, and transactions to the new point of sale",
        "Search by SKU and name": "Search by SKU and name",
        "SKU": "SKU",
        "Specifications": "Specifications",
        "No specifications": "No specifications",
        "No items were found in the catalog": "No items were found in the catalog",
        "The name of the cash register is required": "The name of the point of sale is required",
        "The address of the cash register is required": "The address of the point of sale is required",
        "Please select a city to set the timezone for the cash register": "Please select a city to set the timezone for the point of sale",
        "Please select at least one payment method": "Please select at least one payment method",
        "Select a default currency": "Select a default currency",
        "New income / expense": "New income / expense",
        "Income / Expense": "Income / Expense",
        "Income": "Income",
        "Expense": "Expense",
        "Payment method": "Payment method",
        "Transaction type": "Transaction type",
        "Type": "Type",
        "Operation": "Operation",
        "Quantity": "Quantity",
        "Pcs": "Pcs",
        "Schedule": "Schedule",
        "Price": "Price",
        "Sum": "Sum",
        "In stock": "In stock",
        "Add operation": "Add operation",
        "Add payout": "Add payout",
        "Add accrual": "Add accrual",
        "The product quantity field is required": "The product quantity field is required",
        "The price field must be greater than zero": "The price field must be greater than zero",
        "Sale": "Sale",
        "Client": "Client",
        "Discount": "Discount",
        "Product / Service": "Product / Service",
        "Add product": "Add product",
        "Discount must be between 0 and 99": "Discount must be between 0 and 99",
        "The product quantity cannot exceed the available stock": "The product quantity cannot exceed the available stock",
        "Transfer": "Transfer",
        "To": "To",
        "From": "From",
        "Currency": "Currency",
        "The sum field is required": "The sum field is required",
        "The amount cannot exceed the current cash balance of {currency} in the cash register": "The amount cannot exceed the current cash balance of {currency} in the point of sale",
        "What do you want to do with the remaining products in the cash register when deleting it?": "What do you want to do with the remaining products in the point of sale when deleting it?",
        "Transfer the remaining products to the main warehouse": "Transfer the remaining products to the main warehouse",
        "Delete the remaining products": "Delete the remaining products",
        "Please choose one of the options": "Please choose one of the options",
        "Export CSV": "Export CSV",
        "Export period": "Export period",
        "Operating system": "Operating system",
        "The period cannot exceed 1 year": "The period cannot exceed 1 year",
        "The start date cannot exceed the end date": "The start date cannot exceed the end date",
        "Please specify the period": "Please specify the period",
        "Total cash balance": "Total cash balance",
        "Total card balance": "Total card balance",
        "Total terminal balance": "Total terminal balance",
        "Total account balance": "Total account balance",
        "Go to the cash register": "Go to the point of sale",
        "You currently have no cash registers": "You currently have no points of sale",
        "Transactions": "Transactions",
        "Tasks": "Tasks",
        "Task": "Task",
        "New task": "New task",
        "New sale": "New sale",
        "Today": "Today",
        "Yesterday": "Yesterday",
        "Specify the period": "Specify the period",
        "year": "year",
        "Confirm": "Confirm",
        "Search by ID and comment": "Search by ID and comment",
        "Filter": "Filter",
        "Period balance": "Period balance",
        "Total balance": "Total balance",
        "Current balance": "Current balance",
        "All": "All",
        "Open catalog": "Open catalog",
        "Enter at least 5 characters": "Enter at least 5 characters",
        "Enter at least 2 characters": "Enter at least 2 characters",
        "If you didn't find the desired client, please refine your search query": "If you didn't find the desired client, please refine your search query",
        "Cashier": "Cashier",
        "Sum from": "Sum from",
        "Sum to": "Sum to",
        "Reset": "Reset",
        "Total income": "Total income",
        "Total spending": "Total spending",
        "There are no transactions for the selected period": "There are no transactions for the selected period",
        "There are no transactions for the selected period with the specified filter parameters": "There are no transactions for the selected period with the specified filter parameters",
        "Supply to {warehouse}": "Supply to {warehouse}",
        "Write-off from {warehouse}": "Write-off from {warehouse}",
        "Stock transfer to {warehouse}": "Stock transfer to {warehouse}",
        "Stock transfer from {warehouse}": "Stock transfer from {warehouse}",
        "Stock transfer": "Stock transfer",
        "Transfer \"{cashRegisterFrom} → {cashRegisterTo}\"": "Transfer \"{cashRegisterFrom} → {cashRegisterTo}\"",
        "Description": "Description",
        "No current tasks for the selected period": "No current tasks for the selected period",
        "You": "You",
        "Completed": "Completed",
        "Completion date and time": "Completion date and time",
        "Executor": "Executor",
        "Who created": "Who created",
        "Creation date and time": "Creation date and time",
        "Are you sure you want to complete the task?": "Are you sure you want to complete the task?",
        "The description field is required": "The description field is required",
        "Transaction detail": "Transaction detail",
        "Transfer to cash register": "Transfer to point of sale",
        "Transfer from cash register": "Transfer from point of sale",
        "Client name": "Client name",
        "Client phone number": "Client phone number",
        "Client email": "Client email",
        "Total discount": "Total discount",
        "Total before discount": "Total before discount",
        "Are you sure you want to delete this transaction?": "Are you sure you want to delete this transaction?",
        "Cash register editing": "Point of sale editing",
        "Default day shift": "Default day shift",
        "Default night shift": "Default night shift",
        "Work hours": "Work hours",
        "Shift start": "Shift start",
        "Shift end": "Shift end",
        "Apply to selected": "Apply to selected",
        "Staff works at multiple shops — pick a specific cash register in the filter above": "Staff works at multiple shops — pick a specific cash register in the filter above",
        "Contacts": "Contacts",
        "Phone": "Phone",
        "WhatsApp": "WhatsApp",
        "Telegram": "Telegram",
        "Max": "Max",
        "None": "None",
        "Select payment methods": "Select payment methods",
        "New item": "New item",
        "Upload CSV": "Upload CSV",
        "Product": "Product",
        "Products": "Products",
        "Service": "Service",
        "Incoming": "Incoming",
        "Expensing": "Expensing",
        "Selection is required": "Selection is required",
        "Item name is required": "Item name is required",
        "The SKU must contain exactly 6 characters": "The SKU must contain exactly 6 characters",
        "Select a warehouse for delivery": "Select a warehouse for delivery",
        "The quantity must be greater than zero": "The quantity must be greater than zero",
        "New supply": "New supply",
        "Supply": "Supply",
        "Write-off": "Write-off",
        "New stock transfer / write-off": "New stock transfer / write-off",
        "Stock transfer / Write-off": "Stock transfer / Write-off",
        "Select warehouses for transfer / write-off": "Select warehouses for transfer / write-off",
        "The quantity cannot exceed the available amount": "The quantity cannot exceed the available amount",
        "You cannot move products with a quantity of zero": "You cannot move products with a quantity of zero",
        "Select at least one item to add": "Select at least one item to add",
        "Search by name, SKU, or comment": "Search by name, SKU, or comment",
        "Search by name, SKU, or price": "Search by name, SKU, or price",
        "Show": "Show",
        "Hide": "Hide",
        "Attach to a cash register": "Attach to a point of sale",
        "Detach from a cash register": "Detach from a point of sale",
        "Warehouse": "Warehouse",
        "Main warehouse": "Main warehouse",
        "Show hidden items": "Show hidden items",
        "You don’t have any items yet": "You don’t have any items yet",
        "You can’t delete items with a non-zero stock. You need to write off all remaining stock from all warehouses first": "You can’t delete items with a non-zero stock. You need to write off all remaining stock from all warehouses first",
        "You can’t delete an item with a non-zero stock. You need to write off the remaining stock from all warehouses first": "You can’t delete an item with a non-zero stock. You need to write off the remaining stock from all warehouses first",
        "Select a cash register": "Select a point of sale",
        "What do you want to do with the remaining stock?": "What do you want to do with the remaining stock?",
        "Move to the main warehouse": "Move to the main warehouse",
        "Select an action": "Select an action",
        "Select the stock update format": "Select the stock update format",
        "Delete stock": "Delete stock",
        "*Removed warehouse": "*Removed warehouse",
        "You have no supplies, stock transfers, or write-offs for the selected date": "You have no supplies, stock transfers, or write-offs for the selected date",
        "You don’t have any supplies, stock transfers, or write-offs yet": "You don’t have any supplies, stock transfers, or write-offs yet",
        "Write-off details": "Write-off details",
        "Stock transfer details": "Stock transfer details",
        "Supply detail": "Supply detail",
        "Product update": "Product update",
        "Service update": "Service update",
        "Income item update": "Income item update",
        "Expense item update": "Expense item update",
        "An item with this SKU already exists in your catalog": "An item with this SKU already exists in your catalog",
        "Download our template": "Download our template",
        "Required fields: Name and Type": "Required fields: Name and Type",
        "Required fields: Full name and Phone number": "Required fields: Full name and Phone number",
        "The SKU field must be unique and contain no more than 6 characters": "The SKU field must be unique and contain no more than 6 characters",
        "The file is empty": "The file is empty",
        "Invalid CSV headers. Please download the latest CSV template": "Invalid CSV headers. Please download the latest CSV template",
        "Invalid CSV content. Please check the file contents": "Invalid CSV content. Please check the file contents",
        "Too much data. You can upload up to {amount} rows at a time in the CSV file": "Too much data. You can upload up to {amount} rows at a time in the CSV file",
        "SKU length exceeds 6 characters": "SKU length exceeds 6 characters",
        "The SKU may contain only letters and numbers": "The SKU may contain only letters and numbers",
        "The SKU cannot be '000000'": "The SKU cannot be '000000'",
        "Price must be a number": "Price must be a number",
        "Type must be one of the following values: Product, Service, Operation (+), or Operation (−)": "Type must be one of the following values: Product, Service, Operation (+), or Operation (−)",
        "Characteristics cannot contain the characters '=' or ';'": "Characteristics cannot contain the characters '=' or ';'",
        "Duplicate SKUs found": "Duplicate SKUs found",
        "Client phone numbers are duplicated": "Client phone numbers are duplicated",
        "Client emails are duplicated": "Client emails are duplicated",
        "The full name field is required for each client": "The full name field is required for each client",
        "Invalid purchase amount. Please make sure to enter numbers only, using a dot (.) as the decimal separator": "Invalid purchase amount. Please make sure to enter numbers only, using a dot (.) as the decimal separator",
        "Discount value must be a number between 0 and 100 (exclusive)": "Discount value must be a number between 0 and 100 (exclusive)",
        "The phone number field is required for each client": "The phone number field is required for each client",
        "Invalid phone number format": "Invalid phone number format",
        "Data is being uploaded": "Data is being uploaded",
        "Data uploaded successfully": "Data uploaded successfully",
        "An unexpected error occurred. Please try again later or contact support": "An unexpected error occurred. Please try again later or contact support",
        "File size must not exceed 3MB": "File size must not exceed 3MB",
        "The file is valid": "The file is valid",
        "New client": "New client",
        "Personal discount": "Personal discount",
        "General discount policy applies": "General discount policy applies",
        "Discount policy": "Discount policy",
        "Purchase amount": "Purchase amount",
        "Add in another currency": "Add in another currency",
        "The value must be a valid email": "The value must be a valid email",
        "Currencies cannot be repeated": "Currencies cannot be repeated",
        "A client with this phone number already exists in the system": "A client with this phone number already exists in the system",
        "A client with this email already exists in the system": "A client with this email already exists in the system",
        "Client details": "Client details",
        "Client purchase history": "Client purchase history",
        "This client has no purchases yet": "This client has no purchases yet",
        "Search by name, email and phone number": "Search by name, email and phone number",
        "You don’t have any clients yet": "You don’t have any clients yet",
        "Enter name, email or phone number to search": "Enter name, email or phone number to search",
        "Are you sure you want to delete the selected clients?": "Are you sure you want to delete the selected clients?",
        "Are you sure you want to hide the selected clients?": "Are you sure you want to hide the selected clients?",
        "Are you sure you want to show the selected clients?": "Are you sure you want to show the selected clients?",
        "Are you sure you want to hide the client?": "Are you sure you want to hide the client?",
        "Are you sure you want to show the client?": "Are you sure you want to show the client?",
        "Are you sure you want to delete the client?": "Are you sure you want to delete the client?",
        "Add discount step": "Add discount step",
        "The value cannot be negative": "The value cannot be negative",
        "Discount field is required": "Discount field is required",
        "Sum values cannot be repeated": "Sum values cannot be repeated",
        "The Phone Number and Email fields must be unique": "The Phone Number and Email fields must be unique",
        "The passwords do not match": "The passwords do not match",
        "Your account has already been verified": "Your account has already been verified",
        "Create a password": "Create a password",
        "The password must contain at least 8 characters, including numbers, uppercase and lowercase Latin letters": "The password must contain at least 8 characters, including numbers, uppercase and lowercase Latin letters",
        "Password": "Password",
        "Confirm password": "Confirm password",
        "Create": "Create",
        "The link appears to be expired": "The link appears to be expired",
        "Please try requesting the email again": "Please try requesting the email again",
        "Create a password for your account": "Create a password for your account",
        "You have no available companies": "You have no available companies",
        "You have no available options to choose from": "You have no available options to choose from",
        "You are not a member of any company yet. To log in as an employee, a company must first add you. Any company can add you as an employee by entering your personal code": "You are not a member of any company yet. To log in as an employee, a company must first add you. Any company can add you as an employee by entering your personal code",
        "Your personal code": "Your personal code",
        "Successfully copied to clipboard": "Successfully copied to clipboard",
        "Oops! Something went wrong. Try copying the code manually": "Oops! Something went wrong. Try copying the code manually",
        "Sign in as": "Sign in as",
        "Create a company": "Create a company",
        "Company name is required": "Company name is required",
        "Official company name is required": "Official company name is required",
        "Main currency is required": "Main currency is required",
        "Oops! It looks like we can’t find the page you were looking for": "Oops! It looks like we can’t find the page you were looking for",
        "Back to homepage": "Back to homepage",
        "We’ve sent a confirmation email to the address provided. Please check your email": "We’ve sent a confirmation email to the address provided. Please check your email",
        "Update email": "Update email",
        "New email": "New email",
        "Enter your email": "Enter your email",
        "A user with this email already exists": "A user with this email already exists",
        "Please enter an email different from the current one": "Please enter an email different from the current one",
        "Are you sure you want to change your email on the Intilly service?": "Are you sure you want to change your email on the Intilly service?",
        "Your email has been successfully updated! You will be redirected to the sign in page shortly...": "Your email has been successfully updated! You will be redirected to the sign in page shortly...",
        "Email update successfully canceled! You will be redirected to the sign in page shortly...": "Email update successfully canceled! You will be redirected to the sign in page shortly...",
        "Password successfully updated! You will be redirected to the login page shortly...": "Password successfully updated! You will be redirected to the login page shortly...",
        "Create a new password": "Create a new password",
        "New password": "New password",
        "Confirm new password": "Confirm new password",
        "Phone number successfully updated! You will be redirected to the login page shortly...": "Phone number successfully updated! You will be redirected to the login page shortly...",
        "A user with this phone number already exists": "A user with this phone number already exists",
        "Enter new phone number": "Enter new phone number",
        "Update phone number": "Update phone number",
        "New phone number": "New phone number",
        "Enter the system": "Enter the system",
        "Forgot password": "Forgot password",
        "Sign in": "Sign in",
        "Sign in with Apple": "Sign in with Apple",
        "Not registered yet?": "Not registered yet?",
        "Create an account": "Create an account",
        "Reset password": "Reset password",
        "Password reset request": "Password reset request",
        "Enter your password": "Enter your password",
        "Invalid credentials": "Invalid credentials",
        "Please confirm your email first by clicking the link in the email we sent you": "Please confirm your email first by clicking the link in the email we sent you",
        "The user has been removed from the system": "The user has been removed from the system",
        "No user exists with the specified email": "No user exists with the specified email",
        "Registration request received": "Registration request received",
        "Check {email} to confirm your account": "Check {email} to confirm your account",
        "Registration in the system": "Registration in the system",
        "Phone number with country code": "Phone number with country code",
        "I have read and accept": "I have read and accept",
        "User Agreement": "User Agreement",
        "I confirm that I am not a robot": "I confirm that I am not a robot",
        "Already have an account?": "Already have an account?",
        "Enter your full name": "Enter your full name",
        "Enter your phone number": "Enter your phone number",
        "You must accept the user agreement": "You must accept the user agreement",
        "Please confirm that you are not a robot": "Please confirm that you are not a robot",
        "The captcha may have expired. Please try again": "The captcha may have expired. Please try again",
        "You don’t have any available warehouses yet": "You don’t have any available warehouses yet",
        "January": "January",
        "February": "February",
        "March": "March",
        "April": "April",
        "May": "May",
        "June": "June",
        "July": "July",
        "August": "August",
        "September": "September",
        "October": "October",
        "November": "November",
        "December": "December",
        "Salary": "Salary",
        "Advance": "Advance",
        "Sick": "Sick",
        "Penalty": "Penalty",
        "Accrual": "Accrual",
        "Accruals": "Accruals",
        "Payouts and accruals": "Payouts and accruals",
        "Access rights": "Access rights",
        "Create supplies and stock transfers, and delete stock balances": "Create supplies and stock transfers, and delete stock balances",
        "Add products and their specifications": "Add products and their specifications",
        "Edit products and their specifications": "Edit products and their specifications",
        "Delete products and their specifications": "Delete products and their specifications",
        "Edit general product specifications": "Edit general product specifications",
        "Create transactions": "Create transactions",
        "View balances for past periods": "View balances for past periods",
        "Delete the last transaction": "Delete the last transaction",
        "Delete transactions for the last day": "Delete transactions for the last day",
        "Export transactions to CSV": "Export transactions to CSV",
        "View full client database, upload and download clients": "View full client database, upload and download clients",
        "Edit discount policy": "Edit discount policy",
        "Delete and edit clients": "Delete and edit clients",
        "Edit staff schedules": "Edit staff schedules",
        "Add staff payouts": "Add staff payouts",
        "The request to change your phone number has been sent. Please check your email": "The request to change your phone number has been sent. Please check your email",
        "Too many requests. Please try again in 10 minutes": "Too many requests. Please try again in 10 minutes",
        "Password reset request has been sent. Please check your email": "Password reset request has been sent. Please check your email",
        "Email change request has been sent. Please check your email": "Email change request has been sent. Please check your email",
        "Sign in successful!": "Sign in successful!",
        "The cash register has been successfully added": "The point of sale has been successfully added",
        "The cash register data has been successfully updated": "The point of sale data has been successfully updated",
        "The cash register has been successfully deleted": "The point of sale has been successfully deleted",
        "The order of the cash registers has been successfully updated": "The order of the point of sale has been successfully updated",
        "The client has been successfully updated": "The client has been successfully updated",
        "The client has been successfully removed from hidden": "The client has been successfully removed from hidden",
        "The selected clients have been successfully removed from hidden": "The selected clients have been successfully removed from hidden",
        "The client has been successfully added to hidden": "The client has been successfully added to hidden",
        "The selected clients have been successfully added to hidden": "The selected clients have been successfully added to hidden",
        "The client has been successfully deleted": "The client has been successfully deleted",
        "The selected clients have been successfully deleted": "The selected clients have been successfully deleted",
        "Company information has been successfully updated": "Company information has been successfully updated",
        "Specifications have been successfully updated": "Specifications have been successfully updated",
        "The discount policy has been successfully updated": "The discount policy has been successfully updated",
        "Sales in {cashRegister} from {dateFrom} to {dateTo}": "Sales in {cashRegister} from {dateFrom} to {dateTo}",
        "Catalog item export": "Catalog item export",
        "Catalog item template": "Catalog item template",
        "Client export": "Client export",
        "Client template": "Client template",
        "Item successfully added to the catalog": "Item successfully added to the catalog",
        "Item successfully updated": "Item successfully updated",
        "Item successfully removed from hidden": "Item successfully removed from hidden",
        "Selected items successfully removed from hidden": "Selected items successfully removed from hidden",
        "Item successfully added to hidden": "Item successfully added to hidden",
        "Selected items successfully added to hidden": "Selected items successfully added to hidden",
        "Item successfully removed": "Item successfully removed",
        "Selected items have been successfully removed": "Selected items have been successfully removed",
        "Catalog items have been successfully linked to the cash register": "Catalog items have been successfully linked to the point of sale",
        "Catalog items have been successfully unlinked from the cash register": "Catalog items have been successfully unlinked from the point of sale",
        "Payout successfully created": "Payout successfully created",
        "Payout successfully deleted": "Payout successfully deleted",
        "Profile information successfully updated": "Profile information successfully updated",
        "Redirecting to the payment page...": "Redirecting to the payment page...",
        "The entered promo code is not valid. Please try a different one": "The entered promo code is not valid. Please try a different one",
        "You have been successfully switched to the free plan": "You have been successfully switched to the free plan",
        "Promo code successfully applied": "Promo code successfully applied",
        "The promo code has expired and is no longer valid. Please try entering a different one": "The promo code has expired and is no longer valid. Please try entering a different one",
        "The specified promo code was not found. Please check the spelling and try again": "The specified promo code was not found. Please check the spelling and try again",
        "Staff schedule successfully updated": "Staff schedule successfully updated",
        "Staff successfully updated": "Staff successfully updated",
        "Staff order successfully updated": "Staff order successfully updated",
        "Staff successfully added to your company": "Staff successfully added to your company",
        "Staff successfully added to hidden": "Staff successfully added to hidden",
        "Staff successfully removed from hidden": "Staff successfully removed from hidden",
        "Staff successfully deleted": "Staff successfully deleted",
        "Supply successfully added": "Supply successfully added",
        "Stock transfer completed successfully": "Stock transfer completed successfully",
        "Task completed successfully": "Task completed successfully",
        "New task successfully created": "New task successfully created",
        "Sale successfully added": "Sale successfully added",
        "Transfer completed successfully": "Transfer completed successfully",
        "Operation successfully added": "Operation successfully added",
        "Transaction successfully deleted": "Transaction successfully deleted",
        "You need to upgrade your plan": "You need to upgrade your plan",
        "You’ve reached the cash register limit for your current plan.": "You’ve reached the point of sale limit for your current plan.",
        "Please upgrade to a plan with more registers or remove unused ones.": "Please upgrade to a plan with more points of sale or remove unused ones.",
        "Client successfully added": "Client successfully added",
        "You need to delete cash registers": "You need to delete points of sale",
        "You have more cash registers than allowed by the selected plan.": "You have more point of sale than allowed by the selected plan.",
        "Please remove the extra registers before switching to this plan.": "Please remove the extra points of sale before switching to this plan.",
        "You’ve reached the daily limit of cash register operations for your current plan.": "You’ve reached the daily limit of transactions for your current plan.",
        "Please upgrade your plan or wait until tomorrow to continue.": "Please upgrade your plan or wait until tomorrow to continue.",
        "Personal account": "Personal account",
        "Account registration": "Account registration",
        "Role selection": "Role selection",
        "Account confirmation": "Account confirmation",
        "Password reset": "Password reset",
        "Phone number update": "Phone number update",
        "Email update": "Email update",
        "Email update confirmation": "Email update confirmation",
        "Company selection": "Company selection",
        "Page Not Found": "Page Not Found",
        "Oops! Something went wrong...": "Oops! Something went wrong...",
        "Oops! Looks like there’s a problem with your internet connection...": "Oops! Looks like there’s a problem with your internet connection...",
        "The server is undergoing maintenance. Please try again later.": "The server is undergoing maintenance. Please try again later.",
        "Are you sure you want to delete this item?": "Are you sure you want to delete this item?",
        "Are you sure you want to hide this item?": "Are you sure you want to hide this item?",
        "Are you sure you want to show this item?": "Are you sure you want to show this item?",
        "Are you sure you want to show the selected items?": "Are you sure you want to show the selected items?",
        "Are you sure you want to hide the selected items?": "Are you sure you want to hide the selected items?",
        "Are you sure you want to delete the selected items?": "Are you sure you want to delete the selected items?",
        "The specification name cannot be empty": "The specification name cannot be empty",
        "Specification names must be unique": "Specification names must be unique",
        "A target cash register is required": "A target point of sale is required",
        "Withdrawal account is required": "Withdrawal account is required",
        "Deposit account is required": "Deposit account is required",
        "Cash register is required": "Point of sale is required",
        "Warehouse is required": "Warehouse is required",
        "\"From\" field is required": "\"From\" field is required",
        "\"To\" field is required": "\"To\" field is required",
        "Select the currency most commonly used for transactions.": "Select the currency most commonly used for transactions.",
        "It affects:": "It affects:",
        "Sales commission — calculated only in the primary currency": "Sales commission — calculated only in the primary currency",
        "Discounts — applied only to sales in the primary currency": "Discounts — applied only to sales in the primary currency",
        "Before you can delete the payment method, you must transfer the remaining funds from the corresponding balance.": "Before you can delete the payment method, you must transfer the remaining funds from the corresponding balance.",
        "Balance": "Balance",
        "Add staff accruals": "Add staff accruals",
        "Create invoices": "Create invoices",
        "Payout": "Payout",
        "Total salaries for": "Total salaries for",
        "Total penalties": "Total penalties",
        "Total paid out": "Total paid out",
        "Total remaining payout": "Total remaining payout",
        "Calculation by": "Calculation by",
        "Payouts": "Payouts",
        "and": "and",
        "Accrual successfully created": "Accrual successfully created",
        "No payouts or accruals for the selected period": "No payouts or accruals for the selected period",

        // Sales search
        "Sales search": "Sales search",
        "All shops": "All shops",
        "Shop": "Shop",
        "Operation type": "Operation type",
        "Income operations (+)": "Income operations (+)",
        "Expense operations (-)": "Expense operations (-)",

        // Language Block
        "English": "English",
        "Russian": "Russian",

        // CITY BLOCK
        "Moscow": "Moscow",
        "Saint Petersburg": "Saint Petersburg",
        "Yekaterinburg": "Yekaterinburg",
        "Kazan": "Kazan",
        "Novosibirsk": "Novosibirsk",
        "Krasnoyarsk": "Krasnoyarsk",
        "Chelyabinsk": "Chelyabinsk",
        "Omsk": "Omsk",
        "Samara": "Samara",
        "Rostov-on-Don": "Rostov-on-Don",
        "Ufa": "Ufa",
        "Krasnodar": "Krasnodar",
        "Perm": "Perm",
        "Vladivostok": "Vladivostok",
        "Irkutsk": "Irkutsk",
        "Yaroslavl": "Yaroslavl",
        "Voronezh": "Voronezh",
        "Makhachkala": "Makhachkala",
        "Tomsk": "Tomsk",
        "Orenburg": "Orenburg",
        "Kemerovo": "Kemerovo",
        "Tyumen": "Tyumen",
        "Volgograd": "Volgograd",
        "Astrakhan": "Astrakhan",
        "Kirov": "Kirov",
        "Izhevsk": "Izhevsk",
        "Ulyanovsk": "Ulyanovsk",
        "Barnaul": "Barnaul",
        "Vladimir": "Vladimir",
        "Kaliningrad": "Kaliningrad",
        "Nalchik": "Nalchik",
        "Khabarovsk": "Khabarovsk",
        "Stavropol": "Stavropol",
        "Belgorod": "Belgorod",
        "Khanty-Mansiysk": "Khanty-Mansiysk",
        "Surgut": "Surgut",
        "Cheboksary": "Cheboksary",
        "Petrozavodsk": "Petrozavodsk",
        "Kurgan": "Kurgan",
        "Veliky Novgorod": "Veliky Novgorod",
        "Kostroma": "Kostroma",
        "Yoshkar-Ola": "Yoshkar-Ola",
        "Saransk": "Saransk",
        "Yakutsk": "Yakutsk",
        "Vladikavkaz": "Vladikavkaz",
        "Simferopol": "Simferopol",
        "Kursk": "Kursk",
        "Murmansk": "Murmansk",
        "Tambov": "Tambov",
        "Grozny": "Grozny",
        "Tver": "Tver",
        "Tula": "Tula",
        "Blagoveshchensk": "Blagoveshchensk",
        "Chita": "Chita",
        "Pskov": "Pskov",
        "Bryansk": "Bryansk",
        "Ryazan": "Ryazan",
        "Arkhangelsk": "Arkhangelsk",
        "Lipetsk": "Lipetsk",
        "Magadan": "Magadan",
        "Gorno-Altaysk": "Gorno-Altaysk",
        "Syktyvkar": "Syktyvkar",
        "Smolensk": "Smolensk",
        "Birobidzhan": "Birobidzhan",
        "Petropavlovsk-Kamchatsky": "Petropavlovsk-Kamchatsky",
        "Abakan": "Abakan",
        "Sevastopol": "Sevastopol",
        "Anadyr": "Anadyr",
        "Salekhard": "Salekhard",
        "Abidjan": "Abidjan",
        "Accra": "Accra",
        "Addis Ababa": "Addis Ababa",
        "Algeria": "Algeria",
        "Asmara": "Asmara",
        "Bamako": "Bamako",
        "Bangui": "Bangui",
        "Banjul": "Banjul",
        "Bissau": "Bissau",
        "Blantyre": "Blantyre",
        "Brazzaville": "Brazzaville",
        "Bujumbura": "Bujumbura",
        "Cairo": "Cairo",
        "Casablanca": "Casablanca",
        "Ceuta": "Ceuta",
        "Conakry": "Conakry",
        "Dakar": "Dakar",
        "Dar es Salaam": "Dar es Salaam",
        "Djibouti": "Djibouti",
        "Douala": "Douala",
        "Laayoune": "Laayoune",
        "Freetown": "Freetown",
        "Gaborone": "Gaborone",
        "Harare": "Harare",
        "Johannesburg": "Johannesburg",
        "Juba": "Juba",
        "Kampala": "Kampala",
        "Khartoum": "Khartoum",
        "Kigali": "Kigali",
        "Kinshasa": "Kinshasa",
        "Lagos": "Lagos",
        "Libreville": "Libreville",
        "Lomé": "Lomé",
        "Luanda": "Luanda",
        "Lubumbashi": "Lubumbashi",
        "Lusaka": "Lusaka",
        "Malabo": "Malabo",
        "Maputo": "Maputo",
        "Maseru": "Maseru",
        "Mbabane": "Mbabane",
        "Mogadishu": "Mogadishu",
        "Monrovia": "Monrovia",
        "Nairobi": "Nairobi",
        "N'Djamena": "N'Djamena",
        "Niamey": "Niamey",
        "Nouakchott": "Nouakchott",
        "Ouagadougou": "Ouagadougou",
        "Porto-Novo": "Porto-Novo",
        "San José": "San José",
        "Timbuktu": "Timbuktu",
        "Tripoli": "Tripoli",
        "Tunisia": "Tunisia",
        "Windhoek": "Windhoek",
        "Adak": "Adak",
        "Anchorage": "Anchorage",
        "Anguilla": "Anguilla",
        "Antigua": "Antigua",
        "Araguaína": "Araguaína",
        "Buenos Aires": "Buenos Aires",
        "Catamarca": "Catamarca",
        "Comodoro Rivadavia": "Comodoro Rivadavia",
        "Córdoba": "Córdoba",
        "San Salvador de Jujuy": "San Salvador de Jujuy",
        "Logroño": "Logroño",
        "Mendoza": "Mendoza",
        "Río Gallegos": "Río Gallegos",
        "Salta": "Salta",
        "San Juan": "San Juan",
        "San Luis Potosí City": "San Luis Potosí City",
        "Tucumán": "Tucumán",
        "Aruba": "Aruba",
        "Asunción": "Asunción",
        "Atikokan Municipal Airport": "Atikokan Municipal Airport",
        "Bahía Blanca": "Bahía Blanca",
        "Bahía de Banderas": "Bahía de Banderas",
        "Barbados": "Barbados",
        "Belém": "Belém",
        "Belize": "Belize",
        "Lourdes-de-Blanc-Sablon Airport": "Lourdes-de-Blanc-Sablon Airport",
        "Boa Vista": "Boa Vista",
        "Bogotá": "Bogotá",
        "Boise": "Boise",
        "Campo Grande": "Campo Grande",
        "Cancún": "Cancún",
        "Caracas": "Caracas",
        "Cayenne": "Cayenne",
        "Little Cayman": "Little Cayman",
        "Chicago": "Chicago",
        "Chihuahua City": "Chihuahua City",
        "Ciudad Juárez": "Ciudad Juárez",
        "Costa Rica": "Costa Rica",
        "Crestone": "Crestone",
        "Cuiabá": "Cuiabá",
        "Curaçao": "Curaçao",
        "Jim Kelly Field": "Jim Kelly Field",
        "Denver": "Denver",
        "Detroit": "Detroit",
        "Dominica": "Dominica",
        "Edmonton": "Edmonton",
        "San Salvador": "San Salvador",
        "Ensenada": "Ensenada",
        "Goodwin Fort Historical Marker": "Goodwin Fort Historical Marker",
        "Fort Wayne": "Fort Wayne",
        "Fortaleza": "Fortaleza",
        "Nuuk": "Nuuk",
        "Grand Turk": "Grand Turk",
        "Grenada": "Grenada",
        "Guadeloupe": "Guadeloupe",
        "Guatemala": "Guatemala",
        "Guayaquil": "Guayaquil",
        "Guyana": "Guyana",
        "Halifax": "Halifax",
        "Havana": "Havana",
        "Hermosillo": "Hermosillo",
        "Indianapolis": "Indianapolis",
        "Vincennes": "Vincennes",
        "Marengo": "Marengo",
        "Tell City": "Tell City",
        "Inuvik (Mike Zubko) Airport": "Inuvik (Mike Zubko) Airport",
        "Iqaluit": "Iqaluit",
        "Jamaica": "Jamaica",
        "Juneau": "Juneau",
        "Louisville": "Louisville",
        "Kralendijk": "Kralendijk",
        "La Paz": "La Paz",
        "Lima": "Lima",
        "Los Angeles": "Los Angeles",
        "Maceió": "Maceió",
        "Managua": "Managua",
        "Manaus": "Manaus",
        "Marigot": "Marigot",
        "Martinique": "Martinique",
        "Heroica Matamoros": "Heroica Matamoros",
        "Mazatlán": "Mazatlán",
        "Menominee": "Menominee",
        "Merida": "Merida",
        "Metlakatla": "Metlakatla",
        "Mexico City": "Mexico City",
        "Saint Pierre and Miquelon": "Saint Pierre and Miquelon",
        "Moncton": "Moncton",
        "Monterrey": "Monterrey",
        "Montevideo": "Montevideo",
        "Montreal": "Montreal",
        "Montserrat": "Montserrat",
        "Nassau": "Nassau",
        "New York": "New York",
        "Lake Nipigon": "Lake Nipigon",
        "Phnom Penh": "Phnom Penh",
        "New Salem": "New Salem",
        "Panama": "Panama",
        "Pangnirtung Airport": "Pangnirtung Airport",
        "Paramaribo": "Paramaribo",
        "Phoenix": "Phoenix",
        "Port-au-Prince": "Port-au-Prince",
        "Port of Spain": "Port of Spain",
        "Porto Velho": "Porto Velho",
        "Puerto Rico": "Puerto Rico",
        "Punta Arenas": "Punta Arenas",
        "Rainy Lake": "Rainy Lake",
        "Rankin Inlet Airport": "Rankin Inlet Airport",
        "Recife": "Recife",
        "Regina": "Regina",
        "Resolute": "Resolute",
        "Rio Branco": "Rio Branco",
        "Rosario": "Rosario",
        "Santa Izabel do Oeste": "Santa Izabel do Oeste",
        "Santarém": "Santarém",
        "Santiago": "Santiago",
        "Santo Domingo": "Santo Domingo",
        "São Paulo": "São Paulo",
        "Ittoqqortoormiit": "Ittoqqortoormiit",
        "Shiprock": "Shiprock",
        "Sitka": "Sitka",
        "Saint Barthélemy": "Saint Barthélemy",
        "St John's": "St John's",
        "St Peter Port": "St Peter Port",
        "Saint Lucia": "Saint Lucia",
        "Saint Thomas": "Saint Thomas",
        "Swift Current": "Swift Current",
        "Tegucigalpa": "Tegucigalpa",
        "El Tule Municipality": "El Tule Municipality",
        "Thunder Bay": "Thunder Bay",
        "Tijuana": "Tijuana",
        "Toronto": "Toronto",
        "Tortola": "Tortola",
        "Vancouver": "Vancouver",
        "British Virgin Islands": "British Virgin Islands",
        "Whitehorse": "Whitehorse",
        "Winnipeg": "Winnipeg",
        "Yakutat Seamount": "Yakutat Seamount",
        "Yellowknife": "Yellowknife",
        "Casey": "Casey",
        "Davis": "Davis",
        "Port Macquarie": "Port Macquarie",
        "Mawson Peak": "Mawson Peak",
        "McMurdo Sound": "McMurdo Sound",
        "Palmer Station": "Palmer Station",
        "South Pole": "South Pole",
        "Troll research station": "Troll research station",
        "Vostok": "Vostok",
        "Longyearbyen": "Longyearbyen",
        "Aden": "Aden",
        "Almaty": "Almaty",
        "Amman": "Amman",
        "Aktau": "Aktau",
        "Aktobe": "Aktobe",
        "Ashgabat": "Ashgabat",
        "Atyrau": "Atyrau",
        "Baghdad": "Baghdad",
        "Bahrain": "Bahrain",
        "Baku": "Baku",
        "Bangkok": "Bangkok",
        "Beirut": "Beirut",
        "Bishkek": "Bishkek",
        "Brunei": "Brunei",
        "Kolkata": "Kolkata",
        "Choibalsan Airport": "Choibalsan Airport",
        "Chongqing": "Chongqing",
        "Colombo": "Colombo",
        "Dhaka": "Dhaka",
        "Damascus": "Damascus",
        "Dili": "Dili",
        "Dubai": "Dubai",
        "Dushanbe": "Dushanbe",
        "Famagusta": "Famagusta",
        "Gaza": "Gaza",
        "Harbin": "Harbin",
        "Hebron": "Hebron",
        "Ho Chi Minh City": "Ho Chi Minh City",
        "Hong Kong": "Hong Kong",
        "Khovd": "Khovd",
        "Istanbul": "Istanbul",
        "Jakarta": "Jakarta",
        "Jayapura": "Jayapura",
        "Jerusalem": "Jerusalem",
        "Kabul": "Kabul",
        "Kamchatka": "Kamchatka",
        "Karachi": "Karachi",
        "Kashgar": "Kashgar",
        "Kathmandu": "Kathmandu",
        "Khandyga": "Khandyga",
        "Kuala Lumpur": "Kuala Lumpur",
        "Kuching": "Kuching",
        "Kuwait": "Kuwait",
        "Macao": "Macao",
        "Makassar": "Makassar",
        "Manila": "Manila",
        "Muscat": "Muscat",
        "Nicosia": "Nicosia",
        "Novokuznetsk": "Novokuznetsk",
        "Oral": "Oral",
        "Pontianak": "Pontianak",
        "Pyongyang": "Pyongyang",
        "Qatar": "Qatar",
        "Kostanay": "Kostanay",
        "Kyzylorda": "Kyzylorda",
        "Yangon": "Yangon",
        "Riyadh": "Riyadh",
        "Sakhalin Oblast": "Sakhalin Oblast",
        "Samarkand": "Samarkand",
        "Seoul": "Seoul",
        "Shanghai": "Shanghai",
        "Singapore": "Singapore",
        "Srednekolymsk Airport": "Srednekolymsk Airport",
        "Banciao": "Banciao",
        "Tashkent": "Tashkent",
        "Tbilisi": "Tbilisi",
        "Tehran": "Tehran",
        "Thimphu": "Thimphu",
        "Tokyo": "Tokyo",
        "Ulaanbaatar": "Ulaanbaatar",
        "Ürümqi": "Ürümqi",
        "Ust-Nera Airport": "Ust-Nera Airport",
        "Vientiane": "Vientiane",
        "Yerevan": "Yerevan",
        "Azores": "Azores",
        "Bermuda": "Bermuda",
        "Las Palmas de Gran Canaria": "Las Palmas de Gran Canaria",
        "Cabo Verde": "Cabo Verde",
        "Faroe Islands": "Faroe Islands",
        "Beerenberg": "Beerenberg",
        "Funchal": "Funchal",
        "Reykjavik": "Reykjavik",
        "Southern Asia": "Southern Asia",
        "Stanley": "Stanley",
        "Adelaide": "Adelaide",
        "Brisbane": "Brisbane",
        "Broken Hill": "Broken Hill",
        "Tal-Karri": "Tal-Karri",
        "Darwin": "Darwin",
        "Jukla Shāh Khāngah": "Jukla Shāh Khāngah",
        "Hobart": "Hobart",
        "Lindeman Islands National Park": "Lindeman Islands National Park",
        "Lord Howe Rise": "Lord Howe Rise",
        "Melbourne": "Melbourne",
        "Perth": "Perth",
        "Sydney": "Sydney",
        "Ákra Ákri": "Ákra Ákri",
        "Saskatchewan": "Saskatchewan",
        "Yukon": "Yukon",
        "Easter Island": "Easter Island",
        "Cuba": "Cuba",
        "Egypt": "Egypt",
        "Ireland": "Ireland",
        "Iceland": "Iceland",
        "Antananarivo": "Antananarivo",
        "Chagos Trench": "Chagos Trench",
        "Kiritimati": "Kiritimati",
        "Cocos": "Cocos",
        "Kerguelen Plateau": "Kerguelen Plateau",
        "Mahé": "Mahé",
        "Maldives": "Maldives",
        "Mauritius": "Mauritius",
        "Mayotte": "Mayotte",
        "Réunion": "Réunion",
        "Iran": "Iran",
        "Israel": "Israel",
        "Japan": "Japan",
        "Libya": "Libya",
        "New Zealand": "New Zealand",
        "Show Low": "Show Low",
        "Apia": "Apia",
        "Auckland": "Auckland",
        "Bougainville Island": "Bougainville Island",
        "Savannah": "Savannah",
        "Weno": "Weno",
        "Efate": "Efate",
        "Fakaofo": "Fakaofo",
        "Fiji": "Fiji",
        "Funafuti": "Funafuti",
        "Malango": "Malango",
        "Guam": "Guam",
        "Honolulu": "Honolulu",
        "Johnston Atoll": "Johnston Atoll",
        "Sarajevo": "Sarajevo",
        "Tofol": "Tofol",
        "Majuro": "Majuro",
        "Midway Atoll": "Midway Atoll",
        "Nauru": "Nauru",
        "Niue": "Niue",
        "Norfolk Island": "Norfolk Island",
        "Noumea": "Noumea",
        "Pago Pago": "Pago Pago",
        "Palau": "Palau",
        "Pitcairn Islands": "Pitcairn Islands",
        "Kolonia": "Kolonia",
        "Port Moresby": "Port Moresby",
        "Rarotonga": "Rarotonga",
        "Saipan": "Saipan",
        "Samoa": "Samoa",
        "Tahiti": "Tahiti",
        "Tarawa": "Tarawa",
        "Lapaha": "Lapaha",
        "Wake Island": "Wake Island",
        "Wallis and Futuna": "Wallis and Futuna",
        "Colonia": "Colonia",
        "Poland": "Poland",
        "Portugal": "Portugal",
        "Türkiye": "Türkiye",
        "Brazil (Eastern part)": "Brazil (Eastern part)",
        "Brazil (Western part)": "Brazil (Western part)",
        "Canada (Atlantic Time Zone)": "Canada (Atlantic Time Zone)",
        "Canada (Central Time Zone)": "Canada (Central Time Zone)",
        "Canada (Eastern Time Zone)": "Canada (Eastern Time Zone)",
        "Canada (Mountain Time Zone)": "Canada (Mountain Time Zone)",
        "Canada (Pacific Time Zone)": "Canada (Pacific Time Zone)",
        "Chile (Continental part)": "Chile (Continental part)",
        "Alaska (USA)": "Alaska (USA)",
        "Aleutian Islands (USA)": "Aleutian Islands (USA)",
        "Arizona (USA)": "Arizona (USA)",
        "Central Time Zone (USA)": "Central Time Zone (USA)",
        "Eastern Indiana (USA)": "Eastern Indiana (USA)",
        "Eastern Time Zone (USA)": "Eastern Time Zone (USA)",
        "Hawaii (USA)": "Hawaii (USA)",
        "Starke, Indiana (USA)": "Starke, Indiana (USA)",
        "Michigan (USA)": "Michigan (USA)",
        "Mountain Time Zone (USA)": "Mountain Time Zone (USA)",
        "Pacific Time Zone (USA)": "Pacific Time Zone (USA)",
        "Samoa (USA)": "Samoa (USA)",
        "Coordinated Universal Time (UTC)": "Coordinated Universal Time (UTC)",
        "West Siberian Time (Russia)": "West Siberian Time (Russia)",
        "Western European Time (WET)": "Western European Time (WET)",
        "Ushuaia": "Ushuaia",
        "Cambridge Bay": "Cambridge Bay",
        "Coral Harbour": "Coral Harbour",
        "Danmarkshavn": "Danmarkshavn",
        "Dawson Creek": "Dawson Creek",
        "Eirunepe": "Eirunepe",
        "Glace Bay": "Glace Bay",
        "Goose Bay": "Goose Bay",
        "Petersburg, Indiana": "Petersburg, Indiana",
        "Vevay, Indiana": "Vevay, Indiana",
        "Vincennes, Indiana": "Vincennes, Indiana",
        "Winamac, Indiana": "Winamac, Indiana",
        "Monticello, Kentucky": "Monticello, Kentucky",
        "Lower Princess Quarter": "Lower Princess Quarter",
        "Noronha": "Noronha",
        "Bowbells, North Dakota": "Bowbells, North Dakota",
        "Center, North Dakota": "Center, North Dakota",
        "Ojinaga": "Ojinaga",
        "Porto Acre": "Porto Acre",
        "Dumont d’Urville": "Dumont d’Urville",
        "Rothera": "Rothera",
        "Showa": "Showa",
        "Tel Aviv (Jerusalem)": "Tel Aviv (Jerusalem)",
        "Saint Helena": "Saint Helena",
        "Yancowinna": "Yancowinna",
        "Fernando de Noronha": "Fernando de Noronha",
        "Newfoundland and Labrador": "Newfoundland and Labrador",
        "Greenwich (GMT)": "Greenwich (GMT)",
        "Comoros": "Comoros",
        "Kwajalein": "Kwajalein",
        "Mexico (Baja California)": "Mexico (Baja California)",
        "Mexico (General Time Zone)": "Mexico (General Time Zone)",
        "Chatham (New Zealand)": "Chatham (New Zealand)",
        "People's Republic of China": "People's Republic of China",
        "Pacific Standard/Daylight Time (USA & Canada)": "Pacific Standard/Daylight Time (USA & Canada)",
        "Enderbury": "Enderbury",
        "Galápagos Islands": "Galápagos Islands",
        "Gambier": "Gambier",
        "Marquesas Islands": "Marquesas Islands",
        // END CITY BLOCK
        "Found": "Found",
        "Shown": "Shown",
        "Showing": "Showing",
        "of": "of",
        "Total sum": "Total sum",
        "Invoices": "Invoices",
        "Invoice": "Invoice",
        "Create invoice": "Create invoice",
        "No invoices": "No invoices",
        "Search by number, counterparty or INN": "Search by number, counterparty or INN",
        "Counterparty": "Counterparty",
        "Due date": "Due date",
        "Status": "Status",
        "Number": "Number",
        "Note": "Note",
        "Qty": "Qty",
        "New": "New",
        "Issued": "Issued",
        "Overdue": "Overdue",
        "Deleted": "Deleted",
        "Seller details": "Seller details",
        "Buyer details": "Buyer details",
        "Invoice items": "Invoice items",
        "Download PDF": "Download PDF",
        "Mark as issued": "Mark as issued",
        "Add item": "Add item",
        "INN": "INN",
        "KPP": "KPP",
        "BIK": "BIK",
        "Bank name": "Bank name",
        "Settlement account": "Settlement account",
        "Correspondent account": "Correspondent account",
        "Invoice created successfully": "Invoice created successfully",
        "Invoice updated successfully": "Invoice updated successfully",
        "Invoice deleted": "Invoice deleted",
        "Requisites saved": "Requisites saved",
        "Search": "Search",
        "VAT rate": "VAT rate",
        "Without VAT": "Without VAT",
        "VAT": "VAT",
        "Incl. VAT": "Incl. VAT",
        "Searching": "Searching",
        "Director": "Director",
        "Accountant": "Accountant",
        "Mark as paid": "Mark as paid",
        "Paid": "Paid",
        "Outstanding": "Outstanding",
        "Load more": "Load more",
        "due": "due",
        "Share": "Share",
        "Change recipient details": "Change recipient details",
        "Hide recipient details": "Hide recipient details",
        "Recent": "Recent",
        "Bank integration": "Bank integration",
        "Bank": "Bank",
        "Modul Bank": "Modul Bank",
        "T-Bank": "T-Bank",
        "Alfa-Bank": "Alfa-Bank",
        "Tochka Bank": "Tochka Bank",
        "Dashboard": "Dashboard",
        "Cash in register": "Cash in register",
        "Sales today": "Sales today",
        "Expenses today": "Expenses today",
        "Sales for 30 days": "Sales for 30 days",
        "transactions_count": "transactions",
        "Account ID": "Account ID",
        "API token": "API token",
        "Bank integration settings saved": "Bank integration settings saved",
        "Connect": "Connect",
        "Disconnect": "Disconnect",
        "Select accounts to display": "Select accounts to display",
        "Bank accounts": "Bank accounts",
        "Failed to load accounts": "Failed to load accounts",
        "Connected": "Connected",
        "Linked shops": "Linked shops",
        "Appointments": "Appointments",
        "manageAppointmentsPermission": "Manage appointments",
        "Appointment created successfully": "Appointment created successfully",
        "Appointment updated successfully": "Appointment updated successfully",
        "Appointment saved, but sale was not created: no payment method": "Appointment saved, but sale was not created: no payment method",
        "Appointment saved, but sale was not created: transaction limit reached": "Appointment saved, but sale was not created: transaction limit reached",
        "Appointment saved, but sale creation failed": "Appointment saved, but sale creation failed",
        "Appointment deleted": "Appointment deleted",
        "This time is already booked for this master": "This time is already booked for this master",
        "Failed to save appointment": "Failed to save appointment",
        "Master is not scheduled to work on this day": "Master is not scheduled to work on this day",
        "Send message": "Send message",
        "Recipients": "Recipients",
        "Channel": "Channel",
        "Message": "Message",
        "Enter message text": "Enter message text",
        "Send": "Send",
        "Notification": "Notification",
        "Message sent": "Message sent",
        "Failed to send message": "Failed to send message",
        "Your plan has expired or does not include this feature": "Your plan has expired or does not include this feature",
        "You don't have permission to perform this action": "You don't have permission to perform this action",
        "Update detected — please refresh the page": "Update detected — please refresh the page",
        "Notification sent via": "Notification sent via",
        "Send client notifications": "Send client notifications",
        "Daily notification limit reached": "Daily notification limit reached",
        "Notification history": "Notification history",
        "Notifications": "Notifications",
        "No notifications yet": "No notifications yet",
        "Recent notifications": "Recent notifications",
        "Personal MAX consent link for this client": "Personal MAX consent link for this client",
        "Link is valid for 15 minutes. Send it to the client via SMS/messenger.": "Link is valid for 15 minutes. Send it to the client via SMS/messenger.",
        "both channels, whichever the client is linked to": "both channels, whichever the client is linked to",
        "Birthday": "Birthday",
        "Sent": "Sent",
        "Delivered": "Delivered",
        "Blocked": "Blocked",
        "Appointment created": "Appointment created",
        "Confirmed": "Confirmed",
        "Reminder (day before)": "Reminder (day before)",
        "Reminder (2h)": "Reminder (2h)",
        "Cancelled": "Cancelled",
        "Direct message": "Direct message",
        "Unknown": "Unknown",
        "View appointment": "View appointment",
        "Edit appointment": "Edit appointment",
        "New appointment": "New appointment",
        "Add appointment": "Add appointment",
        "Delete appointment": "Delete appointment",
        "Are you sure you want to delete this appointment?": "Are you sure you want to delete this appointment?",
        "Yes, delete": "Yes, delete",
        "Master": "Master",
        "Select master": "Select master",
        "All masters": "All masters",
        "Filter by master": "Filter by master",
        "Search by name or phone...": "Search by name or phone...",
        "No clients found": "No clients found",
        "Payment": "Payment",
        "Not specified": "Not specified",
        "Add service": "Add service",
        "Search service...": "Search service...",
        "No services found": "No services found",
        "Start date": "Start date",
        "Start time": "Start time",
        "End date": "End date",
        "End time": "End time",
        "Done": "Done",
        "Close": "Close",
        "Add at least one service": "Add at least one service",
        "Specify start date and time": "Specify start date and time",
        "Specify end date and time": "Specify end date and time",
        "End must be after start": "End must be after start",
        "Cannot create appointment in the past": "Cannot create appointment in the past",
        "Select payment method for completed appointment": "Select payment method for completed appointment",
        "Forward": "Forward",
        "Week": "Week",
        "Day": "Day",
        "Appointment": "Appointment",
        "Select shop": "Select shop",
        "Online booking": "Online booking",
        "Select a location": "Select a location",
        "Select a master": "Select a master",
        "Any available master": "Any available master",
        "Select a service": "Select a service",
        "Select date and time": "Select date and time",
        "Your details": "Your details",
        "Book appointment": "Book appointment",
        "You're booked!": "You're booked!",
        "Cancel appointment": "Cancel appointment",
        "Confirm cancellation": "Confirm cancellation",
        "No available slots": "No available slots",
        "Booking is not available": "Booking is not available",
        "Details sent to your email": "Details sent to your email",
        "Step": "Step",
        "Appointment cancelled successfully": "Appointment cancelled successfully",
        "Failed to cancel appointment": "Failed to cancel appointment",
        "Failed to create booking": "Failed to create booking",
        "Please fill in all required fields": "Please fill in all required fields",
        "Please complete the captcha": "Please complete the captcha",
        "Created by client": "Created by client",
        "Created by staff": "Created by staff",
        "Appointment confirmed": "Appointment confirmed",
        "Your appointment has been confirmed. See you soon!": "Your appointment has been confirmed. See you soon!",
        "Appointment already processed": "Appointment already processed",
        "Failed to confirm": "Failed to confirm",
        "The link may have expired or the appointment was cancelled.": "The link may have expired or the appointment was cancelled.",
        "Almost done!": "Almost done!",
        "Pending confirmation": "Pending confirmation",
        "Manage your company": "Manage your company",
        "Choose company": "Choose company",
        "Booking link": "Booking link",
        "Copy booking link": "Copy booking link",
        "Copied!": "Copied!",
        "Link": "Link",
        "Work as an employee": "Work as an employee",
        "Invalid phone number": "Invalid phone number",
        "This time slot is no longer available. Please choose another time.": "This time slot is no longer available. Please choose another time.",
        "Invalid email address": "Invalid email address",
        "Please confirm your booking via the link sent to your email.": "Please confirm your booking via the link sent to your email.",
        "If not confirmed within the time limit, the booking will be cancelled automatically.": "If not confirmed within the time limit, the booking will be cancelled automatically.",
        "Duration": "Duration",
        "Your name": "Your name",
        "Your phone": "Your phone",
        "Your email": "Your email",
        "AI concierge": "AI concierge",
        "AI concierge is": "AI concierge is",
        "enabled": "enabled",
        "disabled": "disabled",
        "When disabled, the bot works in classic menu mode.": "When disabled, the bot works in classic menu mode.",
        "Owner instructions (persona)": "Owner instructions (persona)",
        "Maximum 4000 characters. Safety rules are applied on top and cannot be overridden.": "Maximum 4000 characters. Safety rules are applied on top and cannot be overridden.",
        "Example: Be friendly, address customers formally (Вы), always greet by name": "Example: Be friendly, address customers formally, always greet by name",
        "Formal tone": "Formal tone",
        "Friendly tone": "Friendly tone",
        "With greeting": "With greeting",
        "Working hours": "Working hours",
        "Timezone:": "Timezone:",
        "Outside the window the bot queues messages for you to handle.": "Outside the window the bot queues messages for you to handle.",
        "Daily token limit": "Daily token limit",
        "Hard cap across all client conversations for the company. 0 = unlimited.": "Hard cap across all client conversations for the company. 0 = unlimited.",
        "Day off": "Day off",
        "Interval": "Interval",
        "Date exceptions": "Date exceptions",
        "Override the weekly schedule for specific dates (holidays, extra shifts).": "Override the weekly schedule for specific dates (holidays, extra shifts).",
        "No exceptions yet.": "No exceptions yet.",
        "Closed all day": "Closed all day",
        "Add exception": "Add exception",
        "Monday": "Monday",
        "Tuesday": "Tuesday",
        "Wednesday": "Wednesday",
        "Thursday": "Thursday",
        "Friday": "Friday",
        "Saturday": "Saturday",
        "Sunday": "Sunday",
        "Settings": "Settings",
        "Dialogs": "Dialogs",
        "Unanswered": "Unanswered",
        "All states": "All states",
        "All platforms": "All platforms",
        "Awaiting company": "Awaiting company",
        "Active": "Active",
        "Handed off": "Handed off",
        "State": "State",
        "Platform": "Platform",
        "Messages": "Messages",
        "Last activity": "Last activity",
        "No dialogs yet. Once AI starts answering clients, conversations will appear here.": "No dialogs yet. Once AI starts answering clients, conversations will appear here.",
        "Guest": "Guest",
        "View": "View",
        "Error:": "Error:",
        "Only unresolved": "Only unresolved",
        "Mark resolved": "Mark resolved",
        "Marked as resolved": "Marked as resolved",
        "No unanswered messages. Everything is handled.": "No unanswered messages. Everything is handled.",
        "Refresh": "Refresh",
        "Out of hours": "Out of hours",
        "Handoff requested": "Handoff requested",
        "AI error": "AI error",
        "Rate limit": "Rate limit",
        "Token limit": "Token limit",
        "AI disabled": "AI disabled",
        "Resolved": "Resolved",
        "AI concierge settings saved": "AI concierge settings saved",
        "Manage AI concierge": "Manage AI concierge",
        "Remove": "Remove",
        "Reason": "Reason",
        "Received": "Received",
        "Allow AI to create appointments": "Allow AI to create appointments",
        "Prompt length limit reached.": "Prompt length limit reached.",
        "AI will propose the slot and send a Confirm/Cancel button to the client. Unconfirmed requests are auto-cancelled after the booking timeout.": "AI will propose the slot and send a Confirm/Cancel button to the client. Unconfirmed requests are auto-cancelled after the booking timeout.",
    },
    ru: {
        "Statistics": "Статистика",
        "Sales summary": "Сводка продаж",
        "Total revenue": "Общая выручка",
        "Transaction count": "Количество транзакций",
        "Average check": "Средний чек",
        "Revenue trend": "Динамика выручки",
        "Top products": "ТОП",
        "By revenue": "По выручке",
        "By quantity": "По количеству",
        "By expenses": "По расходам",
        "Operations": "Операции",
        "Income operations": "Приходные операции",
        "Expense operations": "Расходные операции",
        "Income total": "Итого приход",
        "Expense total": "Итого расход",
        "Sales total": "Итого продаж (товары + услуги)",
        "Customer analytics": "Аналитика клиентов",
        "Top customers": "Топ клиентов",
        "New customers": "Новые клиенты",
        "Returning customers": "Повторные клиенты",
        "Staff performance": "Эффективность сотрудников",
        "Payment distribution": "Распределение по способам оплаты",
        "No data for the selected period": "Нет данных за выбранный период",
        "Date from": "Дата от",
        "Date to": "Дата до",
        "Good type": "Тип товара",
        "All types": "Все типы",
        "Revenue": "Выручка",
        "Total spent": "Сумма покупок",
        "View statistics": "Просмотр статистики",
        "View bank accounts": "Просмотр банковских счетов",
        "View all appointments": "Просмотр всех записей",
        "Manage appointments": "Управление записями",
        "Edit staff services": "Редактирование услуг мастеров",
        "Master services": "Услуги мастера",
        "Select master to edit services": "Выберите мастера для редактирования услуг",
        "Search services...": "Поиск услуг...",
        "Staff services updated": "Услуги мастера обновлены",
        "Services": "Услуги",
        "min": "мин",
        "No payouts and accruals for the selected period and staff": "Нет выплат и начислений для выбранного периода и сотрудника",
        "D": "Д",
        "N": "Н",
        "A": "П",
        "S": "Б",
        "V": "О",
        "H": "Ч",
        "MON": "ПН",
        "TUE": "ВТ",
        "WED": "СР",
        "THU": "ЧТ",
        "FRI": "ПТ",
        "SAT": "СБ",
        "SUN": "ВС",
        "Your account has been deleted!": "Ваш аккаунт удален!",
        "Delete account": "Удалить аккаунт",
        "Activate": "Активировать",
        "Please wait. Signing out...": "Пожалуйста подождите. Выполняется выход из системы...",
        "Current name": "Текущее название",
        "Current specifications": "Текущие характеристики",
        "No operations": "Нет операций",
        "Add at least one before creating a income / expense": "Добавьте как минимум одну операцию перед созданием дохода / расхода",
        "Add at least one before creating a sale": "Добавьте как минимум один товар или услугу перед созданием продажи",
        "No products and services": "Нет товаров и услуг",
        "Add product or service": "Добавить товар или услугу",
        "More": "Еще",
        "Clients": "Клиенты",
        "Discounts will be applied automatically": "Скидки будут применены автоматически",
        "Update client": "Обновление клиента",
        "Attach": "Прикрепить",
        "Detach": "Открепить",
        "New quantity": "Новое количество",
        "Quantity to": "Количество куда",
        "Quantity from": "Количество откуда",
        "Specification name": "Название характеристики",
        "Specification value": "Значение характеристики",
        "Add specification": "Добавить характеристику",
        "Add value": "Добавить значение",
        "Select all": "Выбрать все",
        "Change role": "Изменить роль",
        "Complete": "Завершить",
        "completed": "завершено",
        "pc": "шт",
        "pcs": "шт",
        "Apply filter": "Применить фильтр",
        "Interface language": "Язык интерфейса",
        "Loading...": "Загрузка...",
        "Sign out": "Выйти",
        "Cash registers": "Точки продаж",
        "Cash register": "Точка продаж",
        "Current cash register": "Текущая точка продаж",
        "Clients and discounts": "Клиенты и скидки",
        "Catalog and supplies": "Каталог и поставки",
        "Catalog": "Каталог",
        "Category": "Категория",
        "Categories": "Категории",
        "All categories": "Все категории",
        "Uncategorized": "Без категории",
        "New category": "Новая категория",
        "Add subcategory": "Добавить подкатегорию",
        "Category name": "Название категории",
        "Parent category": "Родительская категория",
        "Rename": "Переименовать",
        "Delete with subcategories": "Удалить с подкатегориями",
        "Move subcategories up": "Перенести подкатегории наверх",
        "Category successfully added": "Категория успешно добавлена",
        "Category successfully updated": "Категория успешно обновлена",
        "Category successfully deleted": "Категория успешно удалена",
        "This category has subcategories. Choose what to do with them:": "У этой категории есть подкатегории. Выберите, что с ними сделать:",
        "Items in this category will become uncategorized.": "Позиции из этой категории станут без категории.",
        "Select category": "Выберите категорию",
        "Add to category": "Добавить в категорию",
        "Category assigned successfully": "Категория успешно назначена",
        "Failed to select all matching items. Please retry.": "Не удалось выбрать все подходящие позиции. Попробуйте ещё раз.",
        "Failed to load some categories. Please refresh.": "Не удалось загрузить часть категорий. Обновите страницу.",
        "Failed to save category": "Не удалось сохранить категорию",
        "Failed to delete category": "Не удалось удалить категорию",
        "Failed to assign category": "Не удалось назначить категорию",
        "This staff member is already in your company": "Этот сотрудник уже добавлен в вашу компанию",
        "Selected": "Выбрано",
        "Supplies": "Поставки",
        "Schedules and salaries": "Графики и зарплаты",
        "Staff members": "Сотрудники",
        "Staff member": "Сотрудник",
        "Plans": "Тарифы",
        "Your trial period ends today": "Ваш пробный период заканчивается сегодня",
        "Your trial period ends in {days} days": "Ваш пробный период заканчивается через {days} дней",
        "Choose a plan →": "Выбрать тариф →",
        "Your trial period ends today. Please choose the plan that suits you best.": "Ваш пробный период заканчивается сегодня. Пожалуйста, выберите подходящий тариф.",
        "Your trial period ends in {days} days. Please choose the plan that suits you best.": "Ваш пробный период заканчивается через {days} дней. Пожалуйста, выберите подходящий тариф.",
        "Okay": "Окей",
        "Yes, I'm sure": "Да, я уверен",
        "Cancel": "Отмена",
        "Recalculate discounts": "Пересчитать скидки",
        "Keep current discounts": "Оставить текущие скидки",
        "A discount policy is attached to the company's main currency. Would you like to recalculate the discounts for your clients according to the new main currency?": "К главной валюте компании прикреплена политика скидок. Хотите ли вы пересчитать скидки для ваших клиентов в соответствии с новой главной валютой компании?",
        "Save": "Сохранить",
        "Personal data": "Персональные данные",
        "Full name": "ФИО",
        "Name": "Наименование",
        "Company name": "Наименование компании",
        "Official company name": "Официальное наименование компании",
        "Phone number": "Номер телефона",
        "Edit": "Изменить",
        "Copy": "Копировать",
        "Email": "Email",
        "Personal token": "Личный токен",
        "Company data": "Данные компании",
        "Main currency": "Основная валюта",
        "Plan": "Тариф",
        "The token has been successfully copied": "Токен был успешно скопирован",
        "Failed to copy the token...": "Не удалось скопировать токен...",
        "Valid until": "Действует до",
        "month": "месяц",
        "The official company name field is required.": "Поле официального наименования компании обязательно для заполнения.",
        "The company name field is required.": "Поле наименования компании обязательно для заполнения.",
        "The full name field is required.": "Поле фио обязательно для заполнения.",
        "The name field is required": "Поле наименования обязательно для заполнения",
        "Add": "Добавить",
        "New payout": "Новая выплата",
        "New accrual": "Новое начисление",
        "Period": "Период",
        "Payout type": "Тип выплаты",
        "Amount": "Сумма",
        "Salary calculation": "Расчет заработной платы",
        "Created by": "Кто создал",
        "Comment": "Комментарий",
        "The payout amount field is required.": "Поле размера выплаты обязательно для заполнения.",
        "The staff member field is required": "Поле сотрудника обязательно для заполнения",
        "The period field is required": "Поле периода обязательное для заполнения",
        "The payout type field is required": "Поле типа выплаты обязательное для заполнения",
        "New staff member": "Новый сотрудник",
        "Staff member's pay rates": "Ставки сотрудника",
        "Sales commission": "Процент с продаж",
        "Day shift rate": "Ставка за дневную смену",
        "Day hourly rate": "Ставка за дневной час",
        "Night shift rate": "Ставка за ночную смену",
        "Night hourly rate": "Ставка за ночной час",
        "Vacation day rate": "Ставка за отпускной день",
        "Add another rate type": "Добавить другой тип ставки",
        "Add payment method": "Добавить способ оплаты",
        "The phone number field is required.": "Поле номера телефона обязательное",
        "Please enter a valid phone number.": "Введите корректный номер телефона",
        "The token field is required. You can obtain the token from the staff member you wish to add.": "Поле токена обязательное. Вы можете узнать токен у сотрудника, которого хотите добавить",
        "Payout rate types cannot be duplicated.": "Типы ставок не должны повторяться",
        "Staff members cannot be duplicated": "Сотрудники не должны повторяться",
        "User with this token not found. Please make sure the token is correct and that the staff member is registered on Intilly.": "Пользователь с таким токеном не найден. Пожалуйста, убедитесь в правильности токена и что сотрудник зарегистрирован на Intilly.",
        "You cannot add yourself as a staff member.": "Вы не можете добавить себя в качестве сотрудника.",
        "This staff member is already in your company.": "Этот сотрудник уже есть в вашей компании.",
        "Without account (payroll only)": "Без аккаунта (только учёт зарплаты)",
        "Link account": "Привязать аккаунт",
        "Account linked successfully": "Аккаунт успешно привязан",
        "Staff member without account": "Сотрудник без аккаунта",
        "Payout details": "Детали выплаты",
        "Accrual details": "Детали начисления",
        "Delete": "Удалить",
        "deleted": "удалена",
        "Creation date": "Дата создания",
        "Time": "Время",
        "Are you sure you want to delete this payout?": "Вы уверены, что хотите удалить выплату?",
        "Export": "Выгрузить",
        "Export data": "Выгрузка данных",
        "From period": "С периода",
        "To period": "До периода",
        "Add signature form": "Добавить форму подписи",
        "Print export": "Выгрузка на печать",
        "All cash registers": "Все точки продаж",
        "The plugin is in beta and is available to all users for free for testing and feedback purposes": "Плагин находится в бета-версии и доступен всем пользователям бесплатно в целях тестирования и получения обратной связи",
        "You currently have no active staff members": "У вас пока нет ни одного активного сотрудника",
        "You currently have no staff members": "У вас пока нет сотрудников",
        "There are currently no active staff members in the selected cash register": "В выбранной точке продаж пока нет ни одного активного сотрудника",
        "Staff schedule table for {period}": "Таблица графика сотрудников за {period}",
        "Day hours": "Дневные часы",
        "Night hours": "Ночные часы",
        "Day shift": "Дневная смена",
        "Night shift": "Ночная смена",
        "Absence": "Пропуск",
        "Absences": "Пропуски",
        "Sick leave": "Больничный",
        "Sick leaves": "Больничные",
        "Vacation": "Отпуск",
        "Empty": "Пусто",
        "Print": "Напечатать",
        "% from sales": "% с продаж",
        "Day shifts": "Дневные смены",
        "Night shifts": "Ночные смены",
        "Vacation days": "Отпускные дни",
        "Total": "Итого",
        "Penalties": "Штрафы",
        "Paid out": "Выплачено",
        "Remaining payout": "Осталось выплатить",
        "Salary calculation table for {period}": "Таблица расчета заработной платы за {period}",
        "Salary calculation table": "Таблица расчета заработной платы",
        "Payout and accrual table for {period}": "Таблица выплат и начислений за {period}",
        "Payout table": "Таблица выплат",
        "Date": "Дата",
        "Who made": "Кто сделал",
        "No payouts for the selected period": "За выбранный период нет выплат",
        "The work schedule and salary plugin operates on data starting from February 2025": "Плагин графиков работы и заработных плат работает на данных с февраля 2025",
        "Work schedule": "Рабочий график",
        "Sale commission": "Коммиссия с продаж",
        "Schedule table": "Таблица расписания",
        "Staff member's report": "Отчет по сотруднику",
        "Signature": "Подпись",
        "Founder": "Владелец компании",
        "Report creation date": "Дата создания отчета",
        "Hidden staff members remain in the system but cannot perform operations or view data in your company. Are you sure you want to hide the staff member?": "Скрытые сотрудники остаются в системе, но не могут выполнять операции или просматривать данные в вашей компании. Вы уверены, что хотите скрыть сотрудника?",
        "Active staff members regain access to performing operations and viewing data in your company. Are you sure you want to activate this staff member?": "Активные сотрудники снова получают доступ к выполнению операцию и просмотру данных в вашей компании. Вы уверены, что хотите сделать сотрудника активным?",
        "Deleted staff members are removed from your database and lose access to performing operations and viewing data in your company. To grant access to this staff member again, you will need to re-add them. Are you sure you want to delete this staff member?": "Удаленные сотрудники стираются из вашей базы данных и теряют доступ к выполнению операций и просмотру данных в вашей компании. Чтобы заново предоставить доступ для этого сотрудника, вам будет необходимо снова добавить его. Вы уверены, что хотите удалить сотрудника?",
        "Staff member update": "Обновление сотрудника",
        "For those who want to use more and pay less": "Для тех, кто хочет пользоваться больше, а платить меньше",
        "For those who want flexible monthly subscription management": "Для тех, кто хочет гибкое управление подпиской на ежемесячной основе",
        "For those who want to try the service before buying": "Для тех, кто хочет протестировать сервис перед покупкой",
        "Limited number of cash registers": "Ограниченное количество точек продаж",
        "Up to 10 transactions per day": "До 10 транзакций в день",
        "Unlimited number of staff members": "Неограниченное количество сотрудников",
        "Unlimited number of products": "Неограниченное количество товаров",
        "Unlimited number of clients": "Неограниченное количество клиентов",
        "Unlimited number of transactions": "Неограниченное количество транзакций",
        "Selected number of cash registers": "Выбранное количество точек продаж",
        "Free": "Бесплатный",
        "Monthly": "Месячный",
        "Annual": "Годовой",
        "Number of cash registers": "Количество точек продаж",
        "per month": "/ мес",
        "per year": " / год",
        "discount": "скидка",
        "I have a promo code": "У меня есть промо-код",
        "Apply": "Применить",
        "Your current plan": "Ваш текущий тариф",
        "Subscribe": "Подключить",
        "New cash register": "Новая точка продаж",
        "First cash register": "Первая точка продаж",
        "Cash register name": "Наименование точки продаж",
        "Address": "Адрес",
        "City (timezone selection)": "Город (определение часового пояса)",
        "City": "Город",
        "Timezone": "Часовой пояс",
        "Please enter a city": "Пожалуйста, укажите город",
        "Please select a timezone": "Пожалуйста, выберите часовой пояс",
        "No results were found for your query": "По вашему запросу ничего не найдено",
        "Available payment methods": "Доступные способы оплаты",
        "Cash": "Наличные",
        "Card": "Карта",
        "Bank account": "Расчетный счет",
        "Terminal": "Терминал",
        "cash": "Наличные",
        "account": "Расчетный счет",
        "card": "Карта",
        "terminal": "Терминал",
        "cash_today": "Наличных в кассе",
        "card_today": "На карту",
        "terminal_today": "По терминалу",
        "account_today": "На Расчетный счет",
        "Withdrawal account": "Счет списания",
        "Deposit account": "Счет пополнения",
        "Default payment method": "Способ оплаты по умолчанию",
        "The payment method field is required": "Поле способа оплаты обязательное",
        "Not selected": "Не выбрано",
        "Default currency": "Валюта по умолчанию",
        "Staff guide": "Справка для сотрудников",
        "Guide": "Справка",
        "Next": "Далее",
        "Back": "Назад",
        "Adding items, services, and transactions to the new cash register": "Добавление товаров, услуг и операций в новую точку продаж",
        "Search by SKU and name": "Поиск по артикулу и наименованию",
        "SKU": "Артикул",
        "Specifications": "Характеристики",
        "No specifications": "Нет характеристик",
        "No items were found in the catalog": "Не найдено ни одной позиции в каталоге",
        "The name of the cash register is required": "Наименование точки продаж обязательное",
        "The address of the cash register is required": "Адрес точки продаж обязательный",
        "Please select a city to set the timezone for the cash register": "Выберите город для определения часового пояса точки продаж",
        "Please select at least one payment method": "Выберите как минимум один способ оплаты",
        "Select a default currency": "Выберите валюту по умолчанию",
        "New income / expense": "Новый доход / расход",
        "Income / Expense": "Доход / Расход",
        "Income": "Доход",
        "Expense": "Расход",
        "Payment method": "Способ оплаты",
        "Transaction type": "Тип транзакции",
        "Type": "Тип",
        "Operation": "Операция",
        "Quantity": "Количество",
        "Pcs": "Шт.",
        "Schedule": "График",
        "Price": "Цена",
        "Sum": "Сумма",
        "In stock": "В наличии",
        "Add operation": "Добавить операцию",
        "Add payout": "Добавить выплату",
        "Add accrual": "Добавить начисление",
        "The product quantity field is required": "Поле количества товара обязательно для заполнения",
        "The price field must be greater than zero": "Поле цены должно быть строго больше нуля",
        "Sale": "Продажа",
        "Client": "Клиент",
        "Discount": "Скидка",
        "Product / Service": "Товар / Услуга",
        "Add product": "Добавить товар",
        "Discount must be between 0 and 99": "Скидка должна быть от 0 до 99",
        "The product quantity cannot exceed the available stock": "Количество товара не может превышать доступное количество в наличии",
        "Transfer": "Перевод",
        "To": "Куда",
        "From": "Откуда",
        "Currency": "Валюта",
        "The sum field is required": "Поле суммы обязательное",
        "The amount cannot exceed the current cash balance of {currency} in the cash register": "Сумма не может превышать текущего количество наличных {currency} в точке продаж",
        "What do you want to do with the remaining products in the cash register when deleting it?": "Что вы хотите сделать с остатками товаров в точке продаж при удалении?",
        "Transfer the remaining products to the main warehouse": "Перенести остатки на главный склад",
        "Delete the remaining products": "Удалить остатки",
        "Please choose one of the options": "Выберите один из вариантов",
        "Export CSV": "Выгрузка CSV",
        "Export period": "Период выгрузки",
        "Operating system": "Операционная система",
        "The period cannot exceed 1 year": "Период не может превышать 1 год",
        "The start date cannot exceed the end date": "Дата начала не может превышать дату конца",
        "Please specify the period": "Укажите период",
        "Total cash balance": "Общий баланс наличных",
        "Total card balance": "Общий баланс по карте",
        "Total terminal balance": "Общий баланс по терминалу",
        "Total account balance": "Общий баланс по расчетному счету",
        "Go to the cash register": "Перейти в точку продаж",
        "You currently have no cash registers": "У вас пока нет точек продаж",
        "Transactions": "Транзакции",
        "Tasks": "Задачи",
        "Task": "Задача",
        "New task": "Новая задача",
        "New sale": "Новая продажа",
        "Today": "Сегодня",
        "Yesterday": "Вчера",
        "Specify the period": "Указать период",
        "year": "год",
        "Confirm": "Подтвердить",
        "Search by ID and comment": "Поиск по ID и комментарию",
        "Filter": "Фильтр",
        "Period balance": "Баланс периода",
        "Total balance": "Общий баланс",
        "Current balance": "Текущий баланс",
        "All": "Все",
        "Open catalog": "Открыть каталог",
        "Enter at least 5 characters": "Введите минимум 5 символов",
        "Enter at least 2 characters": "Введите минимум 2 символа",
        "If you didn't find the desired client, please refine your search query": "Если вы не нашли нужного клиента, уточните поисковой запрос",
        "Cashier": "Кассир",
        "Sum from": "Сумма от",
        "Sum to": "Сумма до",
        "Reset": "Сбросить",
        "Total income": "Итого доходов",
        "Total spending": "Итого расходов",
        "There are no transactions for the selected period": "За выбранный период нет транзакций",
        "There are no transactions for the selected period with the specified filter parameters": "За выбранный период с указанными параметрами фильтра нет транзакций",
        "Supply to {warehouse}": "Поставка в {warehouse}",
        "Write-off from {warehouse}": "Write-off from {warehouse}",
        "Stock transfer to {warehouse}": "Перемещение в {warehouse}",
        "Stock transfer from {warehouse}": "Перемещение из {warehouse}",
        "Stock transfer": "Перемещение",
        "Transfer \"{cashRegisterFrom} → {cashRegisterTo}\"": "Перевод \"{cashRegisterFrom} → {cashRegisterTo}\"",
        "Description": "Описание",
        "No current tasks for the selected period": "За выбранный период нет текущих задач",
        "You": "Вы",
        "Completed": "Выполнено",
        "Completion date and time": "Дата и время выполнения",
        "Executor": "Исполнитель",
        "Who created": "Кто создал",
        "Creation date and time": "Дата и время создания",
        "Are you sure you want to complete the task?": "Вы уверены, что хотите завершить задачу?",
        "The description field is required": "Поле описания обязательное",
        "Transaction detail": "Детали транзакции",
        "Transfer to cash register": "Перевод в точку продаж",
        "Transfer from cash register": "Перевод из точки продаж",
        "Client name": "Имя клиента",
        "Client phone number": "Номер телефона клиента",
        "Client email": "Email клиента",
        "Total discount": "Итоговая скидка",
        "Total before discount": "Итог до скидки",
        "Are you sure you want to delete this transaction?": "Вы уверены, что хотите удалить эту транзакцию?",
        "Cash register editing": "Редактирование точки продаж",
        "Default day shift": "Дневная смена по умолчанию",
        "Default night shift": "Ночная смена по умолчанию",
        "Work hours": "Часы работы",
        "Shift start": "Начало смены",
        "Shift end": "Конец смены",
        "Apply to selected": "Применить к выбранным",
        "Staff works at multiple shops — pick a specific cash register in the filter above": "У сотрудника несколько магазинов — выберите конкретную точку продаж в фильтре сверху",
        "Contacts": "Контакты",
        "Phone": "Телефон",
        "WhatsApp": "WhatsApp",
        "Telegram": "Telegram",
        "Max": "Max",
        "None": "Нет",
        "Select payment methods": "Выберите способы оплаты",
        "New item": "Новая позиция",
        "Upload CSV": "Загрузить CSV",
        "Product": "Товар",
        "Products": "Товары",
        "Service": "Услуга",
        "Incoming": "Приходная",
        "Expensing": "Расходная",
        "Selection is required": "Выбор опции обязателен",
        "Item name is required": "Наименование позиции обязательное",
        "The SKU must contain exactly 6 characters": "Артикул должен содержать ровно 6 символов",
        "Select a warehouse for delivery": "Выберите склад для поставки",
        "The quantity must be greater than zero": "Количество должно быть больше нуля",
        "New supply": "Новая поставка",
        "Supply": "Поставка",
        "Write-off": "Списание",
        "New stock transfer / write-off": "Новое перемещение / списание",
        "Stock transfer / Write-off": "Перемещение / списание",
        "Select warehouses for transfer / write-off": "Выберите склады для перемещения / списания",
        "The quantity cannot exceed the available amount": "Количество не может быть больше доступного",
        "You cannot move products with a quantity of zero": "Вы не можете сделать перемещение товаров в нулевом количестве",
        "Select at least one item to add": "Выберите минимум одну позицию для добавления",
        "Search by name, SKU, or comment": "Поиск по наименованию, артикулу и комментарию",
        "Search by name, SKU, or price": "Поиск по наименованию, артикулу и цене",
        "Show": "Показать",
        "Hide": "Скрыть",
        "Attach to a cash register": "Прикрепить к точке продаж",
        "Detach from a cash register": "Открепить от точки продаж",
        "Warehouse": "Склад",
        "Main warehouse": "Главный склад",
        "Show hidden items": "Отображать скрытые позиции",
        "You don’t have any items yet": "У вас пока нет позиций",
        "You can’t delete items with a non-zero stock. You need to write off all remaining stock from all warehouses first": "Вы не можете удалить товары с ненулевым остатком. Вам необходимо сначала списать товарные остатки из всех складов",
        "You can’t delete an item with a non-zero stock. You need to write off the remaining stock from all warehouses first": "Вы не можете удалить товар с ненулевым остатком. Вам необходимо сначала списать товарный остаток из всех складов",
        "Select a cash register": "Выберите точку продаж",
        "What do you want to do with the remaining stock?": "Что вы хотите сделать с остатками?",
        "Move to the main warehouse": "Переместить на главный склад",
        "Select an action": "Выберите действие",
        "Select the stock update format": "Выберите формат обновления остатка товара",
        "Delete stock": "Удалить остаток",
        "*Removed warehouse": "*Удаленный склад",
        "You have no supplies, stock transfers, or write-offs for the selected date": "У вас нет поставок, перемещений или списаний за выбранную дату",
        "You don’t have any supplies, stock transfers, or write-offs yet": "У вас пока нет поставок, перемещений или списаний",
        "Write-off details": "Детали списания",
        "Stock transfer details": "Детали перемещения",
        "Supply detail": "Детали поставки",
        "Product update": "Обновление товара",
        "Service update": "Обновление услуги",
        "Income item update": "Обновление доходной операции",
        "Expense item update": "Обновление расходной операции",
        "An item with this SKU already exists in your catalog": "Позиция с таким артикулом уже есть в вашем каталоге",
        "Download our template": "Скачайте наш шаблон",
        "Required fields: Name and Type": "Обязательные поля: Наименование и Тип",
        "Required fields: Full name and Phone number": "Обязательные поля: ФИО и Номер телефона",
        "The SKU field must be unique and contain no more than 6 characters": "Поле Артикул должно быть уникальным и состоять не более чем из 6 символов",
        "The file is empty": "Ваш файл пустой",
        "Invalid CSV headers. Please download the latest CSV template": "Неверные заголовки CSV-файла. Пожалуйста, скачайте актуальный шаблон CSV",
        "Invalid CSV content. Please check the file contents": "Неверный контент CSV-файла. Проверьте содержимое файла",
        "Too much data. You can upload up to {amount} rows at a time in the CSV file": "Слишком много данных. За раз можно загрузить не более {amount} строк в CSV",
        "SKU length exceeds 6 characters": "Длина Артикула превышает 6 символов",
        "The SKU may contain only letters and numbers": "Артикул может содержать только цифры и буквы",
        "The SKU cannot be '000000'": "Артикул не может быть равен '000000'",
        "Price must be a number": "Цена должна быть числом",
        "Type must be one of the following values: Product, Service, Operation (+), or Operation (−)": "Тип должен быть одним из следующих значений: Товар, Услуга, Операция (+), Операция (-)",
        "Characteristics cannot contain the characters '=' or ';'": "Характеристики не могут содержать символы '=' и ';'",
        "Duplicate SKUs found": "Артикулы дублируются",
        "Client phone numbers are duplicated": "Номера телефонов клиентов дублируются",
        "Client emails are duplicated": "Email клиентов дублируются",
        "The full name field is required for each client": "Поле ФИО обязательное у каждого клиента",
        "Invalid purchase amount. Please make sure to enter numbers only, using a dot (.) as the decimal separator": "Неверное значение суммы покупок. Пожалуйста, убедитесь, что вы вводите только числа (в качестве разделителя дробной части необходимо использовать точку)",
        "Discount value must be a number between 0 and 100 (exclusive)": "Значение скидки должно быть числом в диапазоне от 0 до 100 не включительно",
        "The phone number field is required for each client": "Поле номера телефона обязательное у каждого клиента",
        "Invalid phone number format": "Неверный формат номера телефона",
        "Data is being uploaded": "Данные в процессе загрузки",
        "Data uploaded successfully": "Данные успешно загружены",
        "An unexpected error occurred. Please try again later or contact support": "Неожиданная ошибка. Попробуйте снова через некоторое время или обратитесь в поддержку",
        "File size must not exceed 3MB": "Размер файла не может превышать 3МБ",
        "The file is valid": "Файл корректный",
        "New client": "Новый клиент",
        "Personal discount": "Персональная скидка",
        "General discount policy applies": "Действует общая политика скидок",
        "Discount policy": "Политика скидок",
        "Purchase amount": "Сумма покупок",
        "Add in another currency": "Добавить в другой валюте",
        "The value must be a valid email": "Значение должно быть корректным email",
        "Currencies cannot be repeated": "Валюты не могут повторяться",
        "A client with this phone number already exists in the system": "Клиент с таким номером телефона уже существует в системе",
        "A client with this email already exists in the system": "Клиент с таким email уже существует в системе",
        "Client details": "Детали клиента",
        "Client purchase history": "История покупок клиента",
        "This client has no purchases yet": "У этого клиента еще нет покупок",
        "Search by name, email and phone number": "Поиск по имени, email и номеру телефона",
        "You don’t have any clients yet": "У вас пока нет клиентов",
        "Enter name, email or phone number to search": "Введите имя, email или телефон для поиска",
        "Are you sure you want to delete the selected clients?": "Вы уверены, что хотите удалить выбранных клиентов?",
        "Are you sure you want to hide the selected clients?": "Вы уверены, что хотите скрыть выбранных клиентов?",
        "Are you sure you want to show the selected clients?": "Вы уверены, что хотите показать выбранных клиентов?",
        "Are you sure you want to hide the client?": "Вы уверены, что хотите скрыть клиента?",
        "Are you sure you want to show the client?": "Вы уверены, что хотите показать клиента?",
        "Are you sure you want to delete the client?": "Вы уверены, что хотите удалить клиента?",
        "Add discount step": "Добавить шаг скидки",
        "The value cannot be negative": "Значение не может быть отрицательным",
        "Discount field is required": "Поле скидки обязательное",
        "Sum values cannot be repeated": "Значения суммы не могут повторяться",
        "The Phone Number and Email fields must be unique": "Поля Номер телефона и Email должны быть уникальными",
        "The passwords do not match": "Пароли не совпадают",
        "Your account has already been verified": "Ваш аккаунт уже подтвержден",
        "Create a password": "Создайте пароль",
        "The password must contain at least 8 characters, including numbers, uppercase and lowercase Latin letters": "Пароль должен содержать минимум 8 символов, числа, заглавные и строчные буквы на латинице",
        "Password": "Пароль",
        "Confirm password": "Подтверждение пароля",
        "Create": "Создать",
        "The link appears to be expired": "Похоже ссылка устарела",
        "Please try requesting the email again": "Попробуйте запросить письмо еще раз",
        "Create a password for your account": "Придумайте пароль для аккаунта",
        "You have no available companies": "У вас нет доступных организаций",
        "You have no available options to choose from": "У вас нет доступных опций для выбора",
        "You are not a member of any company yet. To log in as an employee, a company must first add you. Any company can add you as an employee by entering your personal code": "Вы пока не состоите ни в одной компании. Чтобы зайти в качестве сотрудника, необходимо, чтобы компания сперва добавила Вас. Любая компания может добавить Вас в качестве сотрудника, указав Ваш личный код",
        "Your personal code": "Ваш личный код",
        "Successfully copied to clipboard": "Успешно скопировано в буфер обмена",
        "Oops! Something went wrong. Try copying the code manually": "Упс! Что-то пошло не так. Попробуйте скопировать код вручную",
        "Sign in as": "Войти как",
        "Create a company": "Создание компании",
        "Company name is required": "Наименование компании обязательное",
        "Official company name is required": "Официальное наименование компании обязательное",
        "Main currency is required": "Основная валюта обязательная",
        "Oops! It looks like we can’t find the page you were looking for": "Упс! Кажется, мы не можем найти страницу, которую вы искали",
        "Back to homepage": "На главную страницу",
        "We’ve sent a confirmation email to the address provided. Please check your email": "Мы отправили письмо с подтверждением на указанный email. Пожалуйста, проверьте указанный email",
        "Update email": "Обновить email",
        "New email": "Новый email",
        "Enter your email": "Введите email",
        "A user with this email already exists": "Пользователь с таким email уже существует",
        "Please enter an email different from the current one": "Введите email, который отличается от текущего",
        "Are you sure you want to change your email on the Intilly service?": "Вы уверены, что хотите изменить email на сервисе Intilly?",
        "Your email has been successfully updated! You will be redirected to the sign in page shortly...": "Ваш email успешно обновлен! Скоро вы будете перенаправлены на страницу входа...",
        "Email update successfully canceled! You will be redirected to the sign in page shortly...": "Изменение email успешно отменено! Скоро вы будете перенаправлены на страницу входа...",
        "Password successfully updated! You will be redirected to the login page shortly...": "Пароль успешно обновлен! Скоро вы будете перенаправлены на страницу входа...",
        "Create a new password": "Создайте новый пароль",
        "New password": "Новый пароль",
        "Confirm new password": "Подтверждение нового пароля",
        "Phone number successfully updated! You will be redirected to the login page shortly...": "Номер телефона успешно обновлен! Скоро вы будете перенаправлены на страницу входа...",
        "A user with this phone number already exists": "Пользователь с таким номером телефона уже существует",
        "Enter new phone number": "Введите новый номер телефона",
        "Update phone number": "Обновить номер телефона",
        "New phone number": "Новый номер",
        "Enter the system": "Войти в систему",
        "Forgot password": "Забыл пароль",
        "Sign in": "Войти",
        "Sign in with Apple": "Войти с Apple",
        "Not registered yet?": "Еще не зарегистрированы?",
        "Create an account": "Создать аккаунт",
        "Reset password": "Сбросить пароль",
        "Password reset request": "Запрос на изменение пароля",
        "Enter your password": "Введите ваш пароль",
        "Invalid credentials": "Неверный данные для входа",
        "Please confirm your email first by clicking the link in the email we sent you": "Сначала подтвердите ваш email, перейдя по ссылке в отправленном письме",
        "The user has been removed from the system": "Пользователь был удален из системы",
        "No user exists with the specified email": "Пользователя с указанным email не существует",
        "Registration request received": "Запрос на регистрацию принят",
        "Check {email} to confirm your account": "Проверьте {email} для подтверждения аккаунта",
        "Registration in the system": "Регистрация в системе",
        "Phone number with country code": "Номер телефона с кодом страны",
        "I have read and accept": "Я ознакомился и принимаю",
        "User Agreement": "Пользовательское соглашение",
        "I confirm that I am not a robot": "Я подтверждаю, что я не робот",
        "Already have an account?": "Уже есть аккаунт?",
        "Enter your full name": "Введите ваше ФИО",
        "Enter your phone number": "Введите номер телефона",
        "You must accept the user agreement": "Необходимо принять пользовательское соглашение",
        "Please confirm that you are not a robot": "Подтвердите, что вы не робот",
        "The captcha may have expired. Please try again": "Возможно captcha устарела. Попробуйте снова",
        "You don’t have any available warehouses yet": "У вас пока нет доступных складов",
        "January": "Январь",
        "February": "Февраль",
        "March": "Март",
        "April": "Апрель",
        "May": "Май",
        "June": "Июнь",
        "July": "Июль",
        "August": "Август",
        "September": "Сентябрь",
        "October": "Октябрь",
        "November": "Ноябрь",
        "December": "Декабрь",
        "Salary": "Зарплата",
        "Advance": "Аванс",
        "Sick": "Больничные",
        "Penalty": "Штраф",
        "Accrual": "Начисление",
        "Accruals": "Начисления",
        "Payouts and accruals": "Выплаты и начисления",
        "Access rights": "Права доступа",
        "Create supplies and stock transfers, and delete stock balances": "Создавать поставки и перемещения товаров и удалять товарные остатки",
        "Add products and their specifications": "Добавлять товары и их характеристики",
        "Edit products and their specifications": "Редактировать товары и их характеристики",
        "Delete products and their specifications": "Удалять товары и их характеристики",
        "Edit general product specifications": "Редактировать общие характеристики товаров ",
        "Create transactions": "Создавать операции в точке продаж",
        "View balances for past periods": "Просмотр балансов за прошлые периоды",
        "Delete the last transaction": "Удалять последнюю операцию в точке продаж",
        "Delete transactions for the last day": "Удалять операции в точке продаж за последний день",
        "Export transactions to CSV": "Выгружать операции в точке продаж в CSV",
        "View full client database, upload and download clients": "Просмотр полной клиентской базы. Загрузка и выгрузка клиентов",
        "Edit discount policy": "Редактировать политику скидок",
        "Delete and edit clients": "Удалять и редактировать клиентов",
        "Edit staff schedules": "Изменять расписание сотрудников",
        "Add staff payouts": "Добавлять выплаты сотрудникам",
        "The request to change your phone number has been sent. Please check your email": "Запрос на изменение телефона отправлен. Проверьте ваш email",
        "Too many requests. Please try again in 10 minutes": "Слишком много запросов. Попробуйте снова через 10 минут",
        "Password reset request has been sent. Please check your email": "Запрос на смену пароля отправлен. Проверьте ваш email",
        "Email change request has been sent. Please check your email": "Запрос на изменение email отправлен. Проверьте ваш email",
        "Sign in successful!": "Вход успешно выполнен!",
        "The cash register has been successfully added": "Точка продаж успешно добавлена",
        "The cash register data has been successfully updated": "Данные точки продаж успешно обновлены",
        "The cash register has been successfully deleted": "Точка продаж успешно удалена",
        "The order of the cash registers has been successfully updated": "Порядок точке продаж успешно обновлен",
        "The client has been successfully updated": "Клиент успешно обновлен",
        "The client has been successfully removed from hidden": "Клиент успешно удален из скрытых",
        "The selected clients have been successfully removed from hidden": "Выбранные клиенты успешно удалены из скрытых",
        "The client has been successfully added to hidden": "Клиент успешно добавлен в скрытые",
        "The selected clients have been successfully added to hidden": "Выбранные клиенты успешно добавлены в скрытые",
        "The client has been successfully deleted": "Клиент успешно удален",
        "The selected clients have been successfully deleted": "Выбранные клиенты успешно удалены",
        "Company information has been successfully updated": "Данные компании успешно обновлены",
        "Specifications have been successfully updated": "Характеристики успешно обновлены",
        "The discount policy has been successfully updated": "Политика скидок успешно обновлена",
        "Sales in {cashRegister} from {dateFrom} to {dateTo}": "Продажи в {cashRegister} за {dateFrom} - {dateTo}",
        "Catalog item export": "Выгрузка позиций каталога",
        "Catalog item template": "Шаблон позиций в каталоге",
        "Client export": "Выгрузка клиентов",
        "Client template": "Шаблон клиентов",
        "Item successfully added to the catalog": "Позиция успешно добавлена в каталог",
        "Item successfully updated": "Позиция успешно обновлена",
        "Item successfully removed from hidden": "Позиция успешно удалена из скрытых",
        "Selected items successfully removed from hidden": "Выбранные позиции успешно удалены из скрытых",
        "Item successfully added to hidden": "Позиция успешно добавлена в скрытые",
        "Selected items successfully added to hidden": "Выбранные позиции успешно добавлены в скрытые",
        "Item successfully removed": "Позиция успешно удалена",
        "Selected items have been successfully removed": "Выбранные позиции успешно удалены",
        "Catalog items have been successfully linked to the cash register": "Позиции каталога успешно прикреплены к точке продаж",
        "Catalog items have been successfully unlinked from the cash register": "Позиции каталога успешно откреплены от точки продаж",
        "Payout successfully created": "Выплата успешно создана",
        "Payout successfully deleted": "Выплата успешно удалена",
        "Profile information successfully updated": "Данные профиля успешно обновлены",
        "Redirecting to the payment page...": "Перенаправляем на страницу оплаты...",
        "The entered promo code is not valid. Please try a different one": "Введенный промокод не действителен. Пожалуйста, попробуйте ввести другой промо-код",
        "You have been successfully switched to the free plan": "Вы успешно переведены на бесплатный тариф",
        "Promo code successfully applied": "Промо-код успешно применен",
        "The promo code has expired and is no longer valid. Please try entering a different one": "Промо-код истек и больше не действителен. Пожалуйста, попробуйте ввести другой промо-код",
        "The specified promo code was not found. Please check the spelling and try again": "Указанный промо-код не найден. Пожалуйста, проверьте корректность ввода",
        "Staff schedule successfully updated": "Расписание сотрудников успешно обновлено",
        "Staff successfully updated": "Сотрудник успешно обновлен",
        "Staff order successfully updated": "Порядок сотрудников успешно обновлен",
        "Staff successfully added to your company": "Сотрудник успешно добавлен в вашу компанию",
        "Staff successfully added to hidden": "Сотрудник успешно добавлен в скрытые",
        "Staff successfully removed from hidden": "Сотрудник успешно удален из скрытых",
        "Staff successfully deleted": "Сотрудник успешно удален",
        "Supply successfully added": "Поставка успешно добавлена",
        "Stock transfer completed successfully": "Перемещение успешно выполнено",
        "Task completed successfully": "Задача успешно завершена",
        "New task successfully created": "Новая задача успешно создана",
        "Sale successfully added": "Продажа успешно добавлена",
        "Transfer completed successfully": "Перевод успешно выполнен",
        "Operation successfully added": "Операция успешно добавлена",
        "Transaction successfully deleted": "Транзакция успешно удалена",
        "You need to upgrade your plan": "Необходимо повысить тарифный план",
        "You’ve reached the cash register limit for your current plan.": "Вы достигли лимита точек продаж по вашему тарифному плану.",
        "Please upgrade to a plan with more registers or remove unused ones.": "Пожалуйста, выберите тариф с большим количеством точек продаж или удалите ненужные точки продаж.",
        "Client successfully added": "Клиент успешно добавлен",
        "You need to delete cash registers": "Необходимо удалить точки продаж",
        "You have more cash registers than allowed by the selected plan.": "У вас больше точек продаж, чем доступно в выбранном тарифе.",
        "Please remove the extra registers before switching to this plan.": "Пожалуйста, перед переходом на этот тариф удалите все лишние точки продаж",
        "You’ve reached the daily limit of cash register operations for your current plan.": "На сегодня вы достигли лимита операций в точках продаж по вашему тарифному плану.",
        "Please upgrade your plan or wait until tomorrow to continue.": "Пожалуйста, выберите другой тариф или подождите до завтра.",
        "Personal account": "Личный кабинет",
        "Account registration": "Регистрация аккаунта",
        "Role selection": "Выбор роли",
        "Account confirmation": "Подтверждение аккаунта",
        "Password reset": "Cброс пароля",
        "Phone number update": "Обновление номера телефона",
        "Email update": "Обновление email",
        "Email update confirmation": "Подтверждение обновления email",
        "Company selection": "Выбор компании",
        "Page Not Found": "Страница не найдена",
        "Oops! Something went wrong...": "Упс! Что-то пошло не так...",
        "Oops! Looks like there’s a problem with your internet connection...": "Упс! Похоже у вас проблемы с подключением к интернету...",
        "The server is undergoing maintenance. Please try again later.": "Ведутся технические работы. Пожалуйста, попробуйте позже.",
        "Are you sure you want to delete this item?": "Вы уверены, что хотите удалить эту позицию?",
        "Are you sure you want to hide this item?": "Вы уверены, что хотите скрыть эту позицию?",
        "Are you sure you want to show this item?": "Вы уверены, что хотите показать эту позицию?",
        "Are you sure you want to show the selected items?": "Вы уверены, что хотите показать выбранные позиции?",
        "Are you sure you want to hide the selected items?": "Вы уверены, что хотите скрыть выбранные позиции?",
        "Are you sure you want to delete the selected items?": "Вы уверены, что хотите удалить выбранные позиции?",
        "The specification name cannot be empty": "Наименование характеристики не может быть пустым",
        "Specification names must be unique": "Наименования характеристик должны быть уникальными",
        "A target cash register is required": "Целевая точка продаж обязательная к заполнению",
        "Withdrawal account is required": "Счет списания обязательный к заполнению",
        "Deposit account is required": "Счет пополнения обязательный к заполнению",
        "Cash register is required": "Точка продаж обязательна к заполнению",
        "Warehouse is required": "Склад обязательный к заполнению",
        "\"From\" field is required": "Поле \"Откуда\" обязательно к заполнению",
        "\"To\" field is required": "Поле \"Куда\" обязательно к заполнению",
        "Select the currency most commonly used for transactions.": "Выберите валюту, в которой чаще всего проходят транзакции.",
        "It affects:": "Это влияет на:",
        "Sales commission — calculated only in the primary currency": "Процент с продаж — начисляется только в основной валюте",
        "Discounts — applied only to sales in the primary currency": "Скидки — применяются только к продажам в основной валюте",
        "Before you can delete the payment method, you must transfer the remaining funds from the corresponding balance.": "Прежде чем вы сможете удалить этот способ оплаты, вам необходимо перевести остатки с соответствующего баланса.",
        "Balance": "Баланс",
        "Add staff accruals": "Добавлять начисления сотрудникам",
        "Create invoices": "Выставление счетов",
        "Payout": "Выплата",
        "Total salaries for": "Итого зарплаты за",
        "Total penalties": "Итого штрафов",
        "Total paid out": "Итого выплачено",
        "Total remaining payout": "Итого осталось выплатить",
        "Calculation by": "Расчет",
        "Payouts": "Выплаты",
        "and": "и",
        "Accrual successfully created": "Начисление успешно создано",
        "No payouts or accruals for the selected period": "Нет выплат или начислений за выбранный период",

        // Sales search
        "Sales search": "Поиск продаж",
        "All shops": "Все точки",
        "Shop": "Точка продаж",
        "Operation type": "Тип операции",
        "Income operations (+)": "Приходные операции (+)",
        "Expense operations (-)": "Расходные операции (-)",

        // Language Block
        "English": "Английский",
        "Russian": "Русский",

        // CITY BLOCK
        "Moscow": "Москва",
        "Saint Petersburg": "Санкт-Петербург",
        "Yekaterinburg": "Екатеринбург",
        "Kazan": "Казань",
        "Novosibirsk": "Новосибирск",
        "Krasnoyarsk": "Красноярск",
        "Chelyabinsk": "Челябинск",
        "Omsk": "Омск",
        "Samara": "Самара",
        "Rostov-on-Don": "Ростов-на-Дону",
        "Ufa": "Уфа",
        "Krasnodar": "Краснодар",
        "Perm": "Пермь",
        "Vladivostok": "Владивосток",
        "Irkutsk": "Иркутск",
        "Yaroslavl": "Ярославль",
        "Voronezh": "Воронеж",
        "Makhachkala": "Махачкала",
        "Tomsk": "Томск",
        "Orenburg": "Оренбург",
        "Kemerovo": "Кемерово",
        "Tyumen": "Тюмень",
        "Volgograd": "Волгоград",
        "Astrakhan": "Астрахань",
        "Kirov": "Киров",
        "Izhevsk": "Ижевск",
        "Ulyanovsk": "Ульяновск",
        "Barnaul": "Барнаул",
        "Vladimir": "Владимир",
        "Kaliningrad": "Калининград",
        "Nalchik": "Нальчик",
        "Khabarovsk": "Хабаровск",
        "Stavropol": "Ставрополь",
        "Belgorod": "Белгород",
        "Khanty-Mansiysk": "Ханты-Мансийск",
        "Surgut": "Сургут",
        "Cheboksary": "Чебоксары",
        "Petrozavodsk": "Петрозаводск",
        "Kurgan": "Курган",
        "Veliky Novgorod": "Великий Новгород",
        "Kostroma": "Кострома",
        "Yoshkar-Ola": "Йошкар-Ола",
        "Saransk": "Саранск",
        "Yakutsk": "Якутск",
        "Vladikavkaz": "Владикавказ",
        "Simferopol": "Симферополь",
        "Kursk": "Курск",
        "Murmansk": "Мурманск",
        "Tambov": "Тамбов",
        "Grozny": "Грозный",
        "Tver": "Тверь",
        "Tula": "Тула",
        "Blagoveshchensk": "Благовещенск",
        "Chita": "Чита",
        "Pskov": "Псков",
        "Bryansk": "Брянск",
        "Ryazan": "Рязань",
        "Arkhangelsk": "Архангельск",
        "Lipetsk": "Липецк",
        "Magadan": "Магадан",
        "Gorno-Altaysk": "Горно-Алтайск",
        "Syktyvkar": "Сыктывкар",
        "Smolensk": "Смоленск",
        "Birobidzhan": "Биробиджан",
        "Petropavlovsk-Kamchatsky": "Петропавловск-Камчатский",
        "Abakan": "Абакан",
        "Sevastopol": "Севастополь",
        "Anadyr": "Анадырь",
        "Salekhard": "Салехард",
        "Abidjan": "Абиджан",
        "Accra": "Аккра",
        "Addis Ababa": "Аддис-Абеба",
        "Algeria": "Алжир",
        "Asmara": "Асмэра",
        "Bamako": "Бамако",
        "Bangui": "Банги",
        "Banjul": "Банджул",
        "Bissau": "Бисау",
        "Blantyre": "Блантайр",
        "Brazzaville": "Браззавиль",
        "Bujumbura": "Бужумбура",
        "Cairo": "Каир",
        "Casablanca": "Касабланка",
        "Ceuta": "Сеута",
        "Conakry": "Конакри",
        "Dakar": "Дакар",
        "Dar es Salaam": "Дар-эс-Салам",
        "Djibouti": "Джибути",
        "Douala": "Дуала",
        "Laayoune": "Эль-Аюн",
        "Freetown": "Фритаун",
        "Gaborone": "Габороне",
        "Harare": "Хараре",
        "Johannesburg": "Йоханнесбург",
        "Juba": "Джуба",
        "Kampala": "Кампала",
        "Khartoum": "Хартум",
        "Kigali": "Кигали",
        "Kinshasa": "Киншаса",
        "Lagos": "Лагос",
        "Libreville": "Либревиль",
        "Lomé": "Ломе",
        "Luanda": "Луанда",
        "Lubumbashi": "Лубумбаши",
        "Lusaka": "Лусака",
        "Malabo": "Малабо",
        "Maputo": "Мапуту",
        "Maseru": "Масеру",
        "Mbabane": "Мбабане",
        "Mogadishu": "Могадишо",
        "Monrovia": "Монровия",
        "Nairobi": "Найроби",
        "N'Djamena": "Нджамена",
        "Niamey": "Ниамей",
        "Nouakchott": "Нуакшот",
        "Ouagadougou": "Уагадугу",
        "Porto-Novo": "Порто-Ново",
        "San José": "Сан-Томе",
        "Timbuktu": "Тимбукту",
        "Tripoli": "Триполи",
        "Tunisia": "Тунис",
        "Windhoek": "Виндхук",
        "Adak": "Адак",
        "Anchorage": "Анкоридж",
        "Anguilla": "Ангилья",
        "Antigua": "Антигуа",
        "Araguaína": "Арагуаина",
        "Buenos Aires": "Буэнос-Айрес",
        "Catamarca": "Катамарка",
        "Comodoro Rivadavia": "Комодоро-Ривадавия",
        "Córdoba": "Кордова",
        "San Salvador de Jujuy": "Жужуй",
        "Logroño": "Ла-Риоха",
        "Mendoza": "Мендоса",
        "Río Gallegos": "Рио-Гальегос",
        "Salta": "Сальта",
        "San Juan": "Сан-Хуан",
        "San Luis Potosí City": "Сан-Луис",
        "Tucumán": "Тукуман",
        "Aruba": "Аруба",
        "Asunción": "Асунсьон",
        "Atikokan Municipal Airport": "Атикокан",
        "Bahía Blanca": "Баия",
        "Bahía de Banderas": "Баия-де-Бандерас",
        "Barbados": "Барбадос",
        "Belém": "Белен",
        "Belize": "Белиз",
        "Lourdes-de-Blanc-Sablon Airport": "Бланк-Саблон",
        "Boa Vista": "Боа-Виста",
        "Bogotá": "Богота",
        "Boise": "Бойсе",
        "Campo Grande": "Кампу-Гранди",
        "Cancún": "Канкун",
        "Caracas": "Каракас",
        "Cayenne": "Кайенна",
        "Little Cayman": "Кайман",
        "Chicago": "Чикаго",
        "Chihuahua City": "Чиуауа",
        "Ciudad Juárez": "Сьюдад-Хуарес",
        "Costa Rica": "Коста-Рика",
        "Crestone": "Крестон",
        "Cuiabá": "Куяба",
        "Curaçao": "Кюрасао",
        "Jim Kelly Field": "Доусон",
        "Denver": "Денвер",
        "Detroit": "Детройт",
        "Dominica": "Доминика",
        "Edmonton": "Эдмонтон",
        "San Salvador": "Сан-Сальвадор",
        "Ensenada": "Энсенада",
        "Goodwin Fort Historical Marker": "Форт-Нельсон",
        "Fort Wayne": "Форт-Уэйн",
        "Fortaleza": "Форталеза",
        "Nuuk": "Нуук",
        "Grand Turk": "Гранд-Терк",
        "Grenada": "Гренада",
        "Guadeloupe": "Гваделупа",
        "Guatemala": "Гватемала",
        "Guayaquil": "Гуаякиль",
        "Guyana": "Гайана",
        "Halifax": "Галифакс",
        "Havana": "Гавана",
        "Hermosillo": "Эрмосильо",
        "Indianapolis": "Индианаполис",
        "Vincennes": "Нокс, Индиана",
        "Marengo": "Маренго, Индиана",
        "Tell City": "Телл-Сити, Индиана",
        "Inuvik (Mike Zubko) Airport": "Инувик",
        "Iqaluit": "Икалуит",
        "Jamaica": "Ямайка",
        "Juneau": "Джуно",
        "Louisville": "Луисвилл",
        "Kralendijk": "Кралендейк",
        "La Paz": "Мексика (Южная Нижняя Калифорния)",
        "Lima": "Лима",
        "Los Angeles": "Лос-Анджелес",
        "Maceió": "Масейо",
        "Managua": "Манагуа",
        "Manaus": "Манаус",
        "Marigot": "Мариго",
        "Martinique": "Мартиника",
        "Heroica Matamoros": "Матаморос",
        "Mazatlán": "Масатлан",
        "Menominee": "Меномини",
        "Merida": "Мерида",
        "Metlakatla": "Метлакатла",
        "Mexico City": "Мехико",
        "Saint Pierre and Miquelon": "Микелон",
        "Moncton": "Монктон",
        "Monterrey": "Монтеррей",
        "Montevideo": "Монтевидео",
        "Montreal": "Монреаль",
        "Montserrat": "Монтсеррат",
        "Nassau": "Нассау",
        "New York": "Нью-Йорк",
        "Lake Nipigon": "Нипигон",
        "Phnom Penh": "Пномпень",
        "New Salem": "Нью-Салем, Северная Дакота",
        "Panama": "Панама",
        "Pangnirtung Airport": "Пангниртунг",
        "Paramaribo": "Парамарибо",
        "Phoenix": "Финикс",
        "Port-au-Prince": "Порт-о-Пренс",
        "Port of Spain": "Порт-оф-Спейн",
        "Porto Velho": "Порту-Велью",
        "Puerto Rico": "Пуэрто-Рико",
        "Punta Arenas": "Пунта-Аренас",
        "Rainy Lake": "Рейни-Ривер",
        "Rankin Inlet Airport": "Ранкин-Инлет",
        "Recife": "Ресифи",
        "Regina": "Реджайна",
        "Resolute": "Резольют",
        "Rio Branco": "Риу-Бранку",
        "Rosario": "Росарио",
        "Santa Izabel do Oeste": "Санта-Изабел",
        "Santarém": "Сантарен",
        "Santiago": "Сантьяго",
        "Santo Domingo": "Санто-Доминго",
        "São Paulo": "Сан-Паулу",
        "Ittoqqortoormiit": "Иттоккортоормиит",
        "Shiprock": "Шипрок",
        "Sitka": "Ситка",
        "Saint Barthélemy": "Сен-Бартелеми",
        "St John's": "Сент-Джонс",
        "St Peter Port": "Сент-Винсент",
        "Saint Lucia": "Сент-Люсия",
        "Saint Thomas": "Сент-Томас",
        "Swift Current": "Свифт-Каррент",
        "Tegucigalpa": "Тегусигальпа",
        "El Tule Municipality": "Туле",
        "Thunder Bay": "Тандер-Бей",
        "Tijuana": "Тихуана",
        "Toronto": "Торонто",
        "Tortola": "Тортола",
        "Vancouver": "Ванкувер",
        "British Virgin Islands": "Вирджин",
        "Whitehorse": "Уайтхорс",
        "Winnipeg": "Виннипег",
        "Yakutat Seamount": "Якутат",
        "Yellowknife": "Йеллоунайф",
        "Casey": "Кейси",
        "Davis": "Дэвис",
        "Port Macquarie": "Маккуори",
        "Mawson Peak": "Моусон",
        "McMurdo Sound": "Мак-Мердо",
        "Palmer Station": "Палмер",
        "South Pole": "Южный полюс",
        "Troll research station": "Тролл",
        "Vostok": "Восток",
        "Longyearbyen": "Лонгйир",
        "Aden": "Аден",
        "Almaty": "Алматы",
        "Amman": "Амман",
        "Aktau": "Актау",
        "Aktobe": "Актобе",
        "Ashgabat": "Ашхабад",
        "Atyrau": "Атырау",
        "Baghdad": "Багдад",
        "Bahrain": "Бахрейн",
        "Baku": "Баку",
        "Bangkok": "Бангкок",
        "Beirut": "Бейрут",
        "Bishkek": "Бишкек",
        "Brunei": "Бруней",
        "Kolkata": "Колката",
        "Choibalsan Airport": "Чойбалсан",
        "Chongqing": "Чунцин",
        "Colombo": "Коломбо",
        "Dhaka": "Дака",
        "Damascus": "Дамаск",
        "Dili": "Дили",
        "Dubai": "Дубай",
        "Dushanbe": "Душанбе",
        "Famagusta": "Фамагуста",
        "Gaza": "Газа",
        "Harbin": "Харбин",
        "Hebron": "Хеврон",
        "Ho Chi Minh City": "Хошимин",
        "Hong Kong": "Гонконг",
        "Khovd": "Ховд",
        "Istanbul": "Стамбул",
        "Jakarta": "Джакарта",
        "Jayapura": "Джаяпура",
        "Jerusalem": "Иерусалим",
        "Kabul": "Кабул",
        "Kamchatka": "Камчатка",
        "Karachi": "Карачи",
        "Kashgar": "Кашгар",
        "Kathmandu": "Катманду",
        "Khandyga": "Хандыга",
        "Kuala Lumpur": "Куала-Лумпур",
        "Kuching": "Кучинг",
        "Kuwait": "Кувейт",
        "Macao": "Макао",
        "Makassar": "Макассар",
        "Manila": "Манила",
        "Muscat": "Маскат",
        "Nicosia": "Никосия",
        "Novokuznetsk": "Новокузнецк",
        "Oral": "Уральск",
        "Pontianak": "Понтианак",
        "Pyongyang": "Пхеньян",
        "Qatar": "Катар",
        "Kostanay": "Костанай",
        "Kyzylorda": "Кызылорда",
        "Yangon": "Янгон",
        "Riyadh": "Эр-Рияд",
        "Sakhalin Oblast": "Сахалин",
        "Samarkand": "Самарканд",
        "Seoul": "Сеул",
        "Shanghai": "Шанхай",
        "Singapore": "Сингапур",
        "Srednekolymsk Airport": "Среднеколымск",
        "Banciao": "Тайбэй",
        "Tashkent": "Ташкент",
        "Tbilisi": "Тбилиси",
        "Tehran": "Тегеран",
        "Thimphu": "Тхимпху",
        "Tokyo": "Токио",
        "Ulaanbaatar": "Улан-Батор",
        "Ürümqi": "Урумчи",
        "Ust-Nera Airport": "Усть-Нера",
        "Vientiane": "Вьентьян",
        "Yerevan": "Ереван",
        "Azores": "Азорские острова",
        "Bermuda": "Бермудские острова",
        "Las Palmas de Gran Canaria": "Канарские острова",
        "Cabo Verde": "Кабо-Верде",
        "Faroe Islands": "Фарерские острова",
        "Beerenberg": "Ян-Майен",
        "Funchal": "Мадейра",
        "Reykjavik": "Рейкьявик",
        "Southern Asia": "Южная Георгия",
        "Stanley": "Стэнли",
        "Adelaide": "Аделаида",
        "Brisbane": "Брисбен",
        "Broken Hill": "Брокен-Хилл",
        "Tal-Karri": "Карри",
        "Darwin": "Дарвин",
        "Jukla Shāh Khāngah": "Юкла",
        "Hobart": "Хобарт",
        "Lindeman Islands National Park": "Линдеман",
        "Lord Howe Rise": "Лорд-Хау",
        "Melbourne": "Мельбурн",
        "Perth": "Перт",
        "Sydney": "Сидней",
        "Ákra Ákri": "Акри",
        "Saskatchewan": "Саскачеван",
        "Yukon": "Юкон",
        "Easter Island": "Пасхи остров",
        "Cuba": "Куба",
        "Egypt": "Египет",
        "Ireland": "Ирландия",
        "Iceland": "Исландия",
        "Antananarivo": "Антананариву",
        "Chagos Trench": "Чагос",
        "Kiritimati": "Киритимати",
        "Cocos": "Кокосовые острова",
        "Kerguelen Plateau": "Кергелен",
        "Mahé": "Маэ",
        "Maldives": "Мальдивы",
        "Mauritius": "Маврикий",
        "Mayotte": "Майотта",
        "Réunion": "Реюньон",
        "Iran": "Иран",
        "Israel": "Израиль",
        "Japan": "Япония",
        "Libya": "Ливия",
        "New Zealand": "Новая Зеландия",
        "Show Low": "Навахо",
        "Apia": "Апиа",
        "Auckland": "Окленд",
        "Bougainville Island": "Бугенвиль",
        "Savannah": "Чатем",
        "Weno": "Чуук (Трук)",
        "Efate": "Эфате",
        "Fakaofo": "Факаофо",
        "Fiji": "Фиджи",
        "Funafuti": "Фунафути",
        "Malango": "Гуадалканал",
        "Guam": "Гуам",
        "Honolulu": "Гонолулу",
        "Johnston Atoll": "Джонстон",
        "Sarajevo": "Кантон",
        "Tofol": "Косрае",
        "Majuro": "Маджуро",
        "Midway Atoll": "Мидуэй",
        "Nauru": "Науру",
        "Niue": "Ниуэ",
        "Norfolk Island": "Норфолк",
        "Noumea": "Нумеа",
        "Pago Pago": "Паго-Паго",
        "Palau": "Палау",
        "Pitcairn Islands": "Питкэрн",
        "Kolonia": "Понпеи",
        "Port Moresby": "Порт-Морсби",
        "Rarotonga": "Раротонга",
        "Saipan": "Сайпан",
        "Samoa": "Самоа",
        "Tahiti": "Таити",
        "Tarawa": "Тарава",
        "Lapaha": "Тонгатапу",
        "Wake Island": "Уэйк",
        "Wallis and Futuna": "Уоллис",
        "Colonia": "Яп",
        "Poland": "Польша",
        "Portugal": "Португалия",
        "Türkiye": "Турция",
        "Brazil (Eastern part)": "Бразилия (восточная часть)",
        "Brazil (Western part)": "Бразилия (западная часть)",
        "Canada (Atlantic Time Zone)": "Канада (Атлантический часовой пояс)",
        "Canada (Central Time Zone)": "Канада (Центральный часовой пояс)",
        "Canada (Eastern Time Zone)": "Канада (Восточный часовой пояс)",
        "Canada (Mountain Time Zone)": "Канада (Горный часовой пояс)",
        "Canada (Pacific Time Zone)": "Канада (Тихоокеанский часовой пояс)",
        "Chile (Continental part)": "Чили (континентальная часть)",
        "Alaska (USA)": "Аляска (США)",
        "Aleutian Islands (USA)": "Алеутские острова (США)",
        "Arizona (USA)": "Аризона (США)",
        "Central Time Zone (USA)": "Центральный часовой пояс (США)",
        "Eastern Indiana (USA)": "Восточная Индиана (США)",
        "Eastern Time Zone (USA)": "Восточный часовой пояс (США)",
        "Hawaii (USA)": "Гавайи (США)",
        "Starke, Indiana (USA)": "Старк, Индиана (США)",
        "Michigan (USA)": "Мичиган (США)",
        "Mountain Time Zone (USA)": "Горный часовой пояс (США)",
        "Pacific Time Zone (USA)": "Тихоокеанский часовой пояс (США)",
        "Samoa (USA)": "Самоа (США)",
        "Coordinated Universal Time (UTC)": "Всемирное координированное время (UTC)",
        "West Siberian Time (Russia)": "Западно-Сибирское время (Россия)",
        "Western European Time (WET)": "Западноевропейское время (WET)",
        "Ushuaia": "Ушуайя",
        "Cambridge Bay": "Кембридж-Бей",
        "Coral Harbour": "Корал-Харбор",
        "Danmarkshavn": "Данмарксхавн",
        "Dawson Creek": "Доусон-Крик",
        "Eirunepe": "Эйрунепе",
        "Glace Bay": "Глейс-Бей",
        "Goose Bay": "Гус-Бей",
        "Petersburg, Indiana": "Питерсберг, Индиана",
        "Vevay, Indiana": "Вивей, Индиана",
        "Vincennes, Indiana": "Винсеннес, Индиана",
        "Winamac, Indiana": "Винамак, Индиана",
        "Monticello, Kentucky": "Монтиселло, Кентукки",
        "Lower Princess Quarter": "Лоуэр-Принсес-Квотер",
        "Noronha": "Норонья",
        "Bowbells, North Dakota": "Бойла, Северная Дакота",
        "Center, North Dakota": "Центр, Северная Дакота",
        "Ojinaga": "Охинага",
        "Porto Acre": "Порту-Акри",
        "Dumont d’Urville": "Дюмон-д’Юрвиль",
        "Rothera": "Ротера",
        "Showa": "Сёва",
        "Tel Aviv (Jerusalem)": "Тель-Авив (Иерусалим)",
        "Saint Helena": "Святая Елена",
        "Yancowinna": "Янкауинна",
        "Fernando de Noronha": "Фернанду-ди-Норонья",
        "Newfoundland and Labrador": "Ньюфаундленд и Лабрадор",
        "Greenwich (GMT)": "Гринвич (GMT)",
        "Comoros": "Коморские острова",
        "Kwajalein": "Кваджалейн",
        "Mexico (Baja California)": "Мексика (Северная Нижняя Калифорния)",
        "Mexico (General Time Zone)": "Мексика (общий часовой пояс)",
        "Chatham (New Zealand)": "Чатем (Новая Зеландия)",
        "People's Republic of China": "Китайская Народная Республика",
        "Pacific Standard/Daylight Time (USA & Canada)": "Тихоокеанский стандартный/летний час (США и Канада)",
        "Enderbury": "Эндербери",
        "Galápagos Islands": "Галапагосские острова",
        "Gambier": "Гамбье",
        "Marquesas Islands": "Маркизские острова",
        // END CITY BLOCK
        "Found": "Найдено",
        "Shown": "Показано",
        "Showing": "Показано",
        "of": "из",
        "Total sum": "Общая сумма",
        "Invoices": "Счета",
        "Invoice": "Счёт",
        "Create invoice": "Создать счёт",
        "No invoices": "Нет счетов",
        "Search by number, counterparty or INN": "Поиск по номеру, контрагенту или ИНН",
        "Counterparty": "Контрагент",
        "Due date": "Срок оплаты",
        "Status": "Статус",
        "Number": "Номер",
        "Note": "Комментарий",
        "Qty": "Кол-во",
        "New": "Новый",
        "Issued": "Выставлен",
        "Overdue": "Просрочен",
        "Deleted": "Удалён",
        "Seller details": "Реквизиты продавца",
        "Buyer details": "Реквизиты покупателя",
        "Invoice items": "Позиции счёта",
        "Download PDF": "Скачать PDF",
        "Mark as issued": "Отметить как выставленный",
        "Add item": "Добавить позицию",
        "INN": "ИНН",
        "KPP": "КПП",
        "BIK": "БИК",
        "Bank name": "Наименование банка",
        "Settlement account": "Расчётный счёт",
        "Correspondent account": "Корреспондентский счёт",
        "Invoice created successfully": "Счёт успешно создан",
        "Invoice updated successfully": "Счёт успешно обновлён",
        "Invoice deleted": "Счёт удалён",
        "Requisites saved": "Реквизиты сохранены",
        "Search": "Найти",
        "VAT rate": "Ставка НДС",
        "Without VAT": "Без НДС",
        "VAT": "НДС",
        "Incl. VAT": "В т.ч. НДС",
        "Searching": "Поиск",
        "Director": "Руководитель",
        "Accountant": "Бухгалтер",
        "Mark as paid": "Отметить как оплаченный",
        "Paid": "Оплачен",
        "Outstanding": "К оплате",
        "Load more": "Загрузить ещё",
        "due": "до",
        "Share": "Поделиться",
        "Change recipient details": "Изменить данные получателя",
        "Hide recipient details": "Скрыть данные получателя",
        "Recent": "Недавние",
        "Bank integration": "Банковская интеграция",
        "Bank": "Банк",
        "Modul Bank": "Модуль Банк",
        "T-Bank": "Т-Банк",
        "Alfa-Bank": "Альфа-Банк",
        "Tochka Bank": "Точка Банк",
        "Dashboard": "Дашборд",
        "Cash in register": "Наличных в кассе",
        "Sales today": "Продажи за сегодня",
        "Expenses today": "Расходные операции",
        "Sales for 30 days": "Продажи за 30 дней",
        "transactions_count": "операций",
        "Account ID": "ID счёта",
        "API token": "API токен",
        "Bank integration settings saved": "Настройки банковской интеграции сохранены",
        "Connect": "Подключить",
        "Disconnect": "Отключить",
        "Select accounts to display": "Выберите счета для отображения",
        "Bank accounts": "Банковские счета",
        "Failed to load accounts": "Не удалось загрузить счета",
        "Connected": "Подключён",
        "Linked shops": "Привязанные точки",
        "Appointments": "Записи",
        "manageAppointmentsPermission": "Управление записями",
        "Appointment created successfully": "Запись успешно создана",
        "Appointment updated successfully": "Запись успешно обновлена",
        "Appointment saved, but sale was not created: no payment method": "Запись сохранена, но продажа не создана: не выбран способ оплаты",
        "Appointment saved, but sale was not created: transaction limit reached": "Запись сохранена, но продажа не создана: превышен лимит транзакций",
        "Appointment saved, but sale creation failed": "Запись сохранена, но не удалось создать продажу",
        "Appointment deleted": "Запись удалена",
        "This time is already booked for this master": "Это время уже занято у данного мастера",
        "Failed to save appointment": "Не удалось сохранить запись",
        "Master is not scheduled to work on this day": "Мастер не стоит в графике на этот день",
        "Send message": "Отправить сообщение",
        "Recipients": "Получатели",
        "Channel": "Канал",
        "Message": "Сообщение",
        "Enter message text": "Введите текст сообщения",
        "Send": "Отправить",
        "Notification": "Уведомление",
        "Message sent": "Сообщение отправлено",
        "Failed to send message": "Не удалось отправить сообщение",
        "Your plan has expired or does not include this feature": "Ваш тариф истёк или не включает эту функцию",
        "You don't have permission to perform this action": "У вас нет прав на это действие",
        "Update detected — please refresh the page": "Обнаружено обновление — обновите страницу",
        "Notification sent via": "Уведомление отправлено через",
        "Send client notifications": "Рассылка уведомлений клиентам",
        "Daily notification limit reached": "Достигнут дневной лимит уведомлений",
        "Notification history": "История уведомлений",
        "Notifications": "Уведомления",
        "No notifications yet": "Уведомлений пока нет",
        "Recent notifications": "Последние уведомления",
        "Personal MAX consent link for this client": "Персональная ссылка для подключения клиента к MAX",
        "Link is valid for 15 minutes. Send it to the client via SMS/messenger.": "Ссылка действует 15 минут. Отправьте её клиенту в SMS или мессенджере.",
        "both channels, whichever the client is linked to": "отправим туда, куда клиент подключён",
        "Birthday": "Дата рождения",
        "Sent": "Отправлено",
        "Delivered": "Доставлено",
        "Blocked": "Заблокирован",
        "Appointment created": "Создание записи",
        "Confirmed": "Подтверждение",
        "Reminder (day before)": "Напоминание (за день)",
        "Reminder (2h)": "Напоминание (за 2ч)",
        "Cancelled": "Отмена",
        "Direct message": "Прямое сообщение",
        "Unknown": "Неизвестно",
        "View appointment": "Просмотр записи",
        "Edit appointment": "Редактировать запись",
        "New appointment": "Новая запись",
        "Add appointment": "Добавить запись",
        "Delete appointment": "Удалить запись",
        "Are you sure you want to delete this appointment?": "Вы уверены, что хотите удалить эту запись?",
        "Yes, delete": "Да, удалить",
        "Master": "Мастер",
        "Select master": "Выберите мастера",
        "All masters": "Все мастера",
        "Filter by master": "Фильтр по мастеру",
        "Search by name or phone...": "Поиск по имени или телефону...",
        "No clients found": "Клиенты не найдены",
        "Payment": "Оплата",
        "Not specified": "Не указан",
        "Add service": "Добавить услугу",
        "Search service...": "Поиск услуги...",
        "No services found": "Услуги не найдены",
        "Start date": "Дата начала",
        "Start time": "Время начала",
        "End date": "Дата конца",
        "End time": "Время конца",
        "Done": "Выполнена",
        "Close": "Закрыть",
        "Add at least one service": "Добавьте хотя бы одну услугу",
        "Specify start date and time": "Укажите дату и время начала",
        "Specify end date and time": "Укажите дату и время окончания",
        "End must be after start": "Конец должен быть позже начала",
        "Cannot create appointment in the past": "Нельзя создать запись на прошедшую дату",
        "Select payment method for completed appointment": "Выберите способ оплаты для завершённой записи",
        "Forward": "Вперёд",
        "Week": "Неделя",
        "Day": "День",
        "Appointment": "Запись",
        "Select shop": "Выберите точку продаж",
        "Online booking": "Онлайн-запись",
        "Select a location": "Выберите филиал",
        "Select a master": "Выберите мастера",
        "Any available master": "Любой свободный мастер",
        "Select a service": "Выберите услугу",
        "Select date and time": "Выберите дату и время",
        "Your details": "Ваши данные",
        "Book appointment": "Записаться",
        "You're booked!": "Вы записаны!",
        "Cancel appointment": "Отменить запись",
        "Confirm cancellation": "Подтвердить отмену",
        "No available slots": "Нет свободных слотов",
        "Booking is not available": "Онлайн-запись недоступна",
        "Details sent to your email": "Подробности отправлены на email",
        "Step": "Шаг",
        "Appointment cancelled successfully": "Запись успешно отменена",
        "Failed to cancel appointment": "Не удалось отменить запись",
        "Failed to create booking": "Не удалось создать запись",
        "Please fill in all required fields": "Пожалуйста, заполните все обязательные поля",
        "Please complete the captcha": "Пожалуйста, пройдите проверку",
        "Created by client": "Создано клиентом",
        "Created by staff": "Создано сотрудником",
        "Appointment confirmed": "Запись подтверждена",
        "Your appointment has been confirmed. See you soon!": "Ваша запись подтверждена. Ждём вас!",
        "Appointment already processed": "Запись уже обработана",
        "Failed to confirm": "Не удалось подтвердить",
        "The link may have expired or the appointment was cancelled.": "Ссылка могла истечь или запись была отменена.",
        "Almost done!": "Почти готово!",
        "Pending confirmation": "Ожидает подтверждения",
        "Manage your company": "Управление компанией",
        "Choose company": "Выберите компанию",
        "Booking link": "Ссылка на запись",
        "Copy booking link": "Скопировать ссылку на онлайн-запись",
        "Copied!": "Скопировано!",
        "Link": "Ссылка",
        "Work as an employee": "Работа как сотрудник",
        "Error": "Ошибка",
        "Event": "Событие",
        "ID": "ID",
        "Loading": "Загрузка",
        "No payouts and accruals for the selected period": "Нет выплат и начислений за выбранный период",
        "Payment methods cannot be empty": "Название способа оплаты не может быть пустым",
        "Payment methods cannot duplicate": "Способы оплаты не могут дублироваться",
        "Payout and accrual table": "Таблица выплат и начислений",
        "The Sum field is required": "Поле Сумма обязательно",
        "You don't have any clients yet": "У вас пока нет клиентов",
        "You don't have warehouse operations in this period": "Нет складских операций за этот период",
        "You don't have warehouse operations yet": "У вас пока нет складских операций",
        "You don't have any staff yet": "У вас пока нет сотрудников",
        "Invalid phone number": "Некорректный номер телефона",
        "This time slot is no longer available. Please choose another time.": "Это время уже занято. Пожалуйста, выберите другое.",
        "Invalid email address": "Некорректный email",
        "Please confirm your booking via the link sent to your email.": "Пожалуйста, подтвердите запись по ссылке, отправленной на вашу почту.",
        "If not confirmed within the time limit, the booking will be cancelled automatically.": "Если не подтвердить в течение указанного времени, запись будет автоматически отменена.",
        "Duration": "Длительность",
        "Your name": "Ваше имя",
        "Your phone": "Ваш телефон",
        "Your email": "Ваш email",
        "AI concierge": "AI-консьерж",
        "AI concierge is": "AI-консьерж",
        "enabled": "включён",
        "disabled": "выключен",
        "When disabled, the bot works in classic menu mode.": "Когда выключен, бот работает в режиме классического меню.",
        "Owner instructions (persona)": "Инструкции владельца (характер бота)",
        "Maximum 4000 characters. Safety rules are applied on top and cannot be overridden.": "Максимум 4000 символов. Правила безопасности применяются выше этих инструкций и не могут быть переопределены.",
        "Example: Be friendly, address customers formally (Вы), always greet by name": "Пример: Отвечай дружелюбно, обращайся на «Вы», всегда здоровайся по имени",
        "Formal tone": "Формальный тон",
        "Friendly tone": "Дружелюбный тон",
        "With greeting": "С приветствием",
        "Working hours": "Часы работы",
        "Timezone:": "Часовой пояс:",
        "Outside the window the bot queues messages for you to handle.": "Вне окна бот складывает сообщения в очередь для вашего разбора.",
        "Daily token limit": "Дневной лимит токенов",
        "Hard cap across all client conversations for the company. 0 = unlimited.": "Общий лимит по всем диалогам компании. 0 = без ограничений.",
        "Day off": "Выходной",
        "Interval": "Интервал",
        "Date exceptions": "Даты-исключения",
        "Override the weekly schedule for specific dates (holidays, extra shifts).": "Переопределить недельный график для конкретных дат (праздники, допсмены).",
        "No exceptions yet.": "Исключений пока нет.",
        "Closed all day": "Закрыто весь день",
        "Add exception": "Добавить исключение",
        "Monday": "Понедельник",
        "Tuesday": "Вторник",
        "Wednesday": "Среда",
        "Thursday": "Четверг",
        "Friday": "Пятница",
        "Saturday": "Суббота",
        "Sunday": "Воскресенье",
        "Settings": "Настройки",
        "Dialogs": "Диалоги",
        "Unanswered": "Эскалации",
        "All states": "Все состояния",
        "All platforms": "Все платформы",
        "Awaiting company": "Ожидает выбора компании",
        "Active": "Активен",
        "Handed off": "Передан администратору",
        "State": "Состояние",
        "Platform": "Платформа",
        "Messages": "Сообщений",
        "Last activity": "Последняя активность",
        "No dialogs yet. Once AI starts answering clients, conversations will appear here.": "Диалогов пока нет. Как только AI начнёт отвечать клиентам, разговоры появятся здесь.",
        "Guest": "Гость",
        "View": "Открыть",
        "Error:": "Ошибка:",
        "Only unresolved": "Только неразобранные",
        "Mark resolved": "Пометить разобранным",
        "Marked as resolved": "Помечено как разобранное",
        "No unanswered messages. Everything is handled.": "Нет необработанных сообщений. Всё разобрано.",
        "Refresh": "Обновить",
        "Out of hours": "Вне часов",
        "Handoff requested": "Просит человека",
        "AI error": "Ошибка AI",
        "Rate limit": "Превышен лимит сообщений",
        "Token limit": "Исчерпан лимит токенов",
        "AI disabled": "AI выключен",
        "Resolved": "Разобрано",
        "AI concierge settings saved": "Настройки AI-консьержа сохранены",
        "Manage AI concierge": "Управление AI-консьержем",
        "Remove": "Удалить",
        "Reason": "Причина",
        "Received": "Получено",
        "Allow AI to create appointments": "Разрешить AI создавать записи",
        "Prompt length limit reached.": "Достигнут лимит длины промпта.",
        "AI will propose the slot and send a Confirm/Cancel button to the client. Unconfirmed requests are auto-cancelled after the booking timeout.": "AI предложит слот и отправит клиенту кнопки «Подтвердить / Отменить». Неподтверждённые запросы автоматически отменяются после таймаута записи.",
    }
};

const i18n = createI18n({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages
});

export default i18n;